import {
  KEYCODE_MAP,
  KEYCODE_MACRO_MAP,
  KEYCODE_TO_WEB_KEY_MAP,
} from "./keyCodeMapper";
import {
  decodeHfdFnV1FuncValue,
  decodeHfdFnV2FuncValue,
  registerHfdFnDisplayName,
  resolveHfdFnFuncDisplayKeyCode,
} from "./hfdFnDisplay";
import {
  getHfdTrustedLayoutRows,
  setHfdTrustedLayoutRows,
  type HfdTrustedLayoutRow,
} from "./hfdTrustedLayoutCache";
export {
  HFD_FN_SYNTHETIC_BASE,
  FUNC_V2_MAP_HFD,
  resolveHfdFnSyntheticKeyInfo,
  isHfdFnSyntheticKeyCode,
} from "./hfdFnDisplay";
export const KEYCODE_MAP_HFD = [
  {
    name: "Esc",
    type: "基础",
    comm: "退出键",
    hex16: "0x29",
    keycode: 41,
    typeof: "basic",
    keyIndex: 0,
  },
  {
    name: "F1",
    type: "基础",
    comm: "功能键 F1",
    hex16: 0x3a,
    keycode: 58,
    typeof: "basic",
    keyIndex: 1,
  },
  {
    name: "F2",
    type: "基础",
    comm: "功能键 F2",
    hex16: 0x3b,
    keycode: 59,
    typeof: "basic",
    keyIndex: 2,
  },
  {
    name: "F3",
    type: "基础",
    comm: "功能键 F3",
    hex16: 0x3c,
    keycode: 60,
    typeof: "basic",
    keyIndex: 3,
  },
  {
    name: "F4",
    type: "基础",
    comm: "功能键 F4",
    hex16: 0x3d,
    keycode: 61,
    typeof: "basic",
    keyIndex: 4,
  },
  {
    name: "F5",
    type: "基础",
    comm: "功能键 F5",
    hex16: 0x3e,
    keycode: 62,
    typeof: "basic",
    keyIndex: 5,
  },
  {
    name: "F6",
    type: "基础",
    comm: "功能键 F6",
    hex16: 0x3f,
    keycode: 63,
    typeof: "basic",
    keyIndex: 6,
  },
  {
    name: "F7",
    type: "基础",
    comm: "功能键 F7",
    hex16: 0x40,
    keycode: 64,
    typeof: "basic",
    keyIndex: 7,
  },
  {
    name: "F8",
    type: "基础",
    comm: "功能键 F8",
    hex16: 0x41,
    keycode: 65,
    typeof: "basic",
    keyIndex: 8,
  },
  {
    name: "F9",
    type: "基础",
    comm: "功能键 F9",
    hex16: 0x42,
    keycode: 66,
    typeof: "basic",
    keyIndex: 9,
  },
  {
    name: "F10",
    type: "基础",
    comm: "功能键 F10",
    hex16: 0x43,
    keycode: 67,
    typeof: "basic",
    keyIndex: 10,
  },
  {
    name: "F11",
    type: "基础",
    comm: "功能键 F11",
    hex16: 0x44,
    keycode: 68,
    typeof: "basic",
    keyIndex: 11,
  },
  {
    name: "F12",
    type: "基础",
    comm: "功能键 F12",
    hex16: 0x45,
    keycode: 69,
    typeof: "basic",
    keyIndex: 12,
  },
  {
    name: "VOLINC",
    type: "基础",
    comm: "音量+",
    hex16: null,
    keycode: 8425,
    typeof: "basic",
    keyIndex: 13,
  },
  {
    name: "VOLDEC",
    type: "基础",
    comm: "音量-",
    hex16: null,
    keycode: 8426,
    typeof: "basic",
    keyIndex: 14,
  },
  {
    name: "MUTE",
    type: "基础",
    comm: "静音",
    hex16: null,
    keycode: 8418,
    typeof: "basic",
    keyIndex: 15,
  },
  {
    name: "GAT",
    type: "基础",
    comm: "反引号 `",
    hex16: 0x35,
    keycode: 53,
    typeof: "basic",
    keyIndex: 16,
  },
  {
    name: "1",
    type: "基础",
    comm: "数字 1",
    hex16: 0x1e,
    keycode: 30,
    typeof: "basic",
    keyIndex: 17,
  },
  {
    name: "2",
    type: "基础",
    comm: "数字 2",
    hex16: 0x1f,
    keycode: 31,
    typeof: "basic",
    keyIndex: 18,
  },
  {
    name: "3",
    type: "基础",
    comm: "数字 3",
    hex16: 0x20,
    keycode: 32,
    typeof: "basic",
    keyIndex: 19,
  },
  {
    name: "4",
    type: "基础",
    comm: "数字 4",
    hex16: 0x21,
    keycode: 33,
    typeof: "basic",
    keyIndex: 20,
  },
  {
    name: "5",
    type: "基础",
    comm: "数字 5",
    hex16: 0x22,
    keycode: 34,
    typeof: "basic",
    keyIndex: 21,
  },
  {
    name: "6",
    type: "基础",
    comm: "数字 6",
    hex16: 0x23,
    keycode: 35,
    typeof: "basic",
    keyIndex: 22,
  },
  {
    name: "7",
    type: "基础",
    comm: "数字 7",
    hex16: 0x24,
    keycode: 36,
    typeof: "basic",
    keyIndex: 23,
  },
  {
    name: "8",
    type: "基础",
    comm: "数字 8",
    hex16: 0x25,
    keycode: 37,
    typeof: "basic",
    keyIndex: 24,
  },
  {
    name: "9",
    type: "基础",
    comm: "数字 9",
    hex16: 0x26,
    keycode: 38,
    typeof: "basic",
    keyIndex: 25,
  },
  {
    name: "0",
    type: "基础",
    comm: "数字 0",
    hex16: 0x27,
    keycode: 39,
    typeof: "basic",
    keyIndex: 26,
  },
  {
    name: "-",
    type: "基础",
    comm: "减号",
    hex16: 0x2d,
    keycode: 45,
    typeof: "basic",
    keyIndex: 27,
  },
  {
    name: "=",
    type: "基础",
    comm: "等号",
    hex16: 0x2e,
    keycode: 46,
    typeof: "basic",
    keyIndex: 28,
  },
  {
    name: "NUMLOCK",
    type: "基础",
    comm: "数字锁定",
    hex16: 0x53,
    keycode: 83,
    typeof: "basic",
    keyIndex: 29,
  },
  {
    name: "PAD/",
    type: "基础",
    comm: "小键盘除号",
    hex16: 0x54,
    keycode: 84,
    typeof: "basic",
    keyIndex: 30,
  },
  {
    name: "PAD*",
    type: "基础",
    comm: "小键盘乘号",
    hex16: 0x55,
    keycode: 85,
    typeof: "basic",
    keyIndex: 31,
  },
  {
    name: "TAB",
    type: "基础",
    comm: "制表键",
    hex16: 0x2b,
    keycode: 43,
    typeof: "basic",
    keyIndex: 32,
  },
  {
    name: "Q",
    type: "基础",
    comm: "字母 Q",
    hex16: 0x14,
    keycode: 20,
    typeof: "basic",
    keyIndex: 33,
  },
  {
    name: "W",
    type: "基础",
    comm: "字母 W",
    hex16: 0x1a,
    keycode: 26,
    typeof: "basic",
    keyIndex: 34,
  },
  {
    name: "E",
    type: "基础",
    comm: "字母 E",
    hex16: 0x08,
    keycode: 8,
    typeof: "basic",
    keyIndex: 35,
  },
  {
    name: "R",
    type: "基础",
    comm: "字母 R",
    hex16: 0x15,
    keycode: 21,
    typeof: "basic",
    keyIndex: 36,
  },
  {
    name: "T",
    type: "基础",
    comm: "字母 T",
    hex16: 0x17,
    keycode: 23,
    typeof: "basic",
    keyIndex: 37,
  },
  {
    name: "Y",
    type: "基础",
    comm: "字母 Y",
    hex16: 0x1c,
    keycode: 28,
    typeof: "basic",
    keyIndex: 38,
  },
  {
    name: "U",
    type: "基础",
    comm: "字母 U",
    hex16: 0x18,
    keycode: 24,
    typeof: "basic",
    keyIndex: 39,
  },
  {
    name: "I",
    type: "基础",
    comm: "字母 I",
    hex16: 0x0c,
    keycode: 12,
    typeof: "basic",
    keyIndex: 40,
  },
  {
    name: "O",
    type: "基础",
    comm: "字母 O",
    hex16: 0x12,
    keycode: 18,
    typeof: "basic",
    keyIndex: 41,
  },
  {
    name: "P",
    type: "基础",
    comm: "字母 P",
    hex16: 0x13,
    keycode: 19,
    typeof: "basic",
    keyIndex: 42,
  },
  {
    name: "[",
    type: "基础",
    comm: "左方括号",
    hex16: 0x2f,
    keycode: 47,
    typeof: "basic",
    keyIndex: 43,
  },
  {
    name: "]",
    type: "基础",
    comm: "右方括号",
    hex16: 0x30,
    keycode: 48,
    typeof: "basic",
    keyIndex: 44,
  },
  {
    name: "PAD7",
    type: "基础",
    comm: "小键盘 7",
    hex16: 0x5f,
    keycode: 95,
    typeof: "basic",
    keyIndex: 45,
  },
  {
    name: "PAD8",
    type: "基础",
    comm: "小键盘 8",
    hex16: 0x60,
    keycode: 96,
    typeof: "basic",
    keyIndex: 46,
  },
  {
    name: "PAD9",
    type: "基础",
    comm: "小键盘 9",
    hex16: 0x61,
    keycode: 97,
    typeof: "basic",
    keyIndex: 47,
  },
  {
    name: "CAPS",
    type: "基础",
    comm: "大写锁定",
    hex16: 0x39,
    keycode: 57,
    typeof: "basic",
    keyIndex: 48,
  },
  {
    name: "A",
    type: "基础",
    comm: "字母 A",
    hex16: 0x04,
    keycode: 4,
    typeof: "basic",
    keyIndex: 49,
  },
  {
    name: "S",
    type: "基础",
    comm: "字母 S",
    hex16: 0x16,
    keycode: 22,
    typeof: "basic",
    keyIndex: 50,
  },
  {
    name: "D",
    type: "基础",
    comm: "字母 D",
    hex16: 0x07,
    keycode: 7,
    typeof: "basic",
    keyIndex: 51,
  },
  {
    name: "F",
    type: "基础",
    comm: "字母 F",
    hex16: 0x09,
    keycode: 9,
    typeof: "basic",
    keyIndex: 52,
  },
  {
    name: "G",
    type: "基础",
    comm: "字母 G",
    hex16: 0x0a,
    keycode: 10,
    typeof: "basic",
    keyIndex: 53,
  },
  {
    name: "H",
    type: "基础",
    comm: "字母 H",
    hex16: 0x0b,
    keycode: 11,
    typeof: "basic",
    keyIndex: 54,
  },
  {
    name: "J",
    type: "基础",
    comm: "字母 J",
    hex16: 0x0d,
    keycode: 13,
    typeof: "basic",
    keyIndex: 55,
  },
  {
    name: "K",
    type: "基础",
    comm: "字母 K",
    hex16: 0x0e,
    keycode: 14,
    typeof: "basic",
    keyIndex: 56,
  },
  {
    name: "L",
    type: "基础",
    comm: "字母 L",
    hex16: 0x0f,
    keycode: 15,
    typeof: "basic",
    keyIndex: 57,
  },
  {
    name: ";",
    type: "基础",
    comm: "分号",
    hex16: 0x33,
    keycode: 51,
    typeof: "basic",
    keyIndex: 58,
  },
  {
    name: "'",
    type: "基础",
    comm: "单引号",
    hex16: 0x34,
    keycode: 52,
    typeof: "basic",
    keyIndex: 59,
  },
  {
    name: "\\",
    type: "基础",
    comm: "反斜杠",
    hex16: 0x31,
    keycode: 49,
    typeof: "basic",
    keyIndex: 60,
  },
  {
    name: "PAD4",
    type: "基础",
    comm: "小键盘 4",
    hex16: 0x5c,
    keycode: 92,
    typeof: "basic",
    keyIndex: 61,
  },
  {
    name: "PAD5",
    type: "基础",
    comm: "小键盘 5",
    hex16: 0x5d,
    keycode: 93,
    typeof: "basic",
    keyIndex: 62,
  },
  {
    name: "PAD6",
    type: "基础",
    comm: "小键盘 6",
    hex16: 0x5e,
    keycode: 94,
    typeof: "basic",
    keyIndex: 63,
  },
  {
    name: "SHIFT_L",
    type: "基础",
    comm: "左 Shift",
    hex16: 0xe1,
    keycode: 225,
    typeof: "basic",
    keyIndex: 64,
  },
  {
    name: "Z",
    type: "基础",
    comm: "字母 Z",
    hex16: 0x1d,
    keycode: 29,
    typeof: "basic",
    keyIndex: 65,
  },
  {
    name: "X",
    type: "基础",
    comm: "字母 X",
    hex16: 0x1b,
    keycode: 27,
    typeof: "basic",
    keyIndex: 66,
  },
  {
    name: "C",
    type: "基础",
    comm: "字母 C",
    hex16: 0x06,
    keycode: 6,
    typeof: "basic",
    keyIndex: 67,
  },
  {
    name: "V",
    type: "基础",
    comm: "字母 V",
    hex16: 0x19,
    keycode: 25,
    typeof: "basic",
    keyIndex: 68,
  },
  {
    name: "B",
    type: "基础",
    comm: "字母 B",
    hex16: 0x05,
    keycode: 5,
    typeof: "basic",
    keyIndex: 69,
  },
  {
    name: "N",
    type: "基础",
    comm: "字母 N",
    hex16: 0x11,
    keycode: 17,
    typeof: "basic",
    keyIndex: 70,
  },
  {
    name: "M",
    type: "基础",
    comm: "字母 M",
    hex16: 0x10,
    keycode: 16,
    typeof: "basic",
    keyIndex: 71,
  },
  {
    name: ",<",
    type: "基础",
    comm: "逗号",
    hex16: 0x36,
    keycode: 54,
    typeof: "basic",
    keyIndex: 72,
  },
  {
    name: ".>",
    type: "基础",
    comm: "句号",
    hex16: 0x37,
    keycode: 55,
    typeof: "basic",
    keyIndex: 73,
  },
  {
    name: "/?",
    type: "基础",
    comm: "斜杠",
    hex16: 0x38,
    keycode: 56,
    typeof: "basic",
    keyIndex: 74,
  },
  {
    name: "SHIFT_R",
    type: "基础",
    comm: "右 Shift",
    hex16: 0xe5,
    keycode: 229,
    typeof: "basic",
    keyIndex: 75,
  },
  {
    name: "ENTER",
    type: "基础",
    comm: "回车键",
    hex16: 0x28,
    keycode: 40,
    typeof: "basic",
    keyIndex: 76,
  },
  {
    name: "PAD1",
    type: "基础",
    comm: "小键盘 1",
    hex16: 0x59,
    keycode: 89,
    typeof: "basic",
    keyIndex: 77,
  },
  {
    name: "PAD2",
    type: "基础",
    comm: "小键盘 2",
    hex16: 0x5a,
    keycode: 90,
    typeof: "basic",
    keyIndex: 78,
  },
  {
    name: "PAD3",
    type: "基础",
    comm: "小键盘 3",
    hex16: 0x5b,
    keycode: 91,
    typeof: "basic",
    keyIndex: 79,
  },
  {
    name: "CTRL_L",
    type: "基础",
    comm: "左 Ctrl",
    hex16: 0xe0,
    keycode: 224,
    typeof: "basic",
    keyIndex: 80,
  },
  {
    name: "WIN_L",
    type: "基础",
    comm: "左 Win",
    hex16: 0xe3,
    keycode: 227,
    typeof: "basic",
    keyIndex: 81,
  },
  {
    name: "ALT_L",
    type: "基础",
    comm: "左 Alt",
    hex16: 0xe2,
    keycode: 226,
    typeof: "basic",
    keyIndex: 82,
  },
  {
    name: "SPACE",
    type: "基础",
    comm: "空格键",
    hex16: 0x2c,
    keycode: 44,
    typeof: "basic",
    keyIndex: 83,
  },
  {
    name: "ALT_R",
    type: "基础",
    comm: "右 Alt",
    hex16: 0xe6,
    keycode: 230,
    typeof: "basic",
    keyIndex: 84,
  },
  {
    name: "FN",
    type: "基础",
    comm: "Fn 键",
    hex16: 0xf101,
    keycode: 61697,
    typeof: "basic",
    keyIndex: 85,
  },
  {
    name: "APP",
    type: "基础",
    comm: "菜单键",
    hex16: 0x65,
    keycode: 101,
    typeof: "basic",
    keyIndex: 86,
  },
  {
    name: "CTRL_R",
    type: "基础",
    comm: "右 Ctrl",
    hex16: 0xe4,
    keycode: 228,
    typeof: "basic",
    keyIndex: 87,
  },
  {
    name: "LEFT",
    type: "基础",
    comm: "左箭头",
    hex16: 0x50,
    keycode: 80,
    typeof: "basic",
    keyIndex: 88,
  },
  {
    name: "DOWN",
    type: "基础",
    comm: "下箭头",
    hex16: 0x51,
    keycode: 81,
    typeof: "basic",
    keyIndex: 89,
  },
  {
    name: "UP",
    type: "基础",
    comm: "上箭头",
    hex16: 0x52,
    keycode: 82,
    typeof: "basic",
    keyIndex: 90,
  },
  {
    name: "RIGHT",
    type: "基础",
    comm: "右箭头",
    hex16: 0x4f,
    keycode: 79,
    typeof: "basic",
    keyIndex: 91,
  },
  {
    name: "BACKSPACE",
    type: "基础",
    comm: "退格键",
    hex16: 0x2a,
    keycode: 42,
    typeof: "basic",
    keyIndex: 92,
  },
  {
    name: "PAD0",
    type: "基础",
    comm: "小键盘 0",
    hex16: 0x62,
    keycode: 98,
    typeof: "basic",
    keyIndex: 93,
  },
  {
    name: "PAD.",
    type: "基础",
    comm: "小键盘小数点",
    hex16: 0x63,
    keycode: 99,
    typeof: "basic",
    keyIndex: 94,
  },
  {
    name: "PAD ENTER.",
    type: "基础",
    comm: "小键盘回车",
    hex16: 0x58,
    keycode: 88,
    typeof: "basic",
    keyIndex: 95,
  },
  {
    name: "CALCU",
    type: "基础",
    comm: "计算器",
    hex16: null,
    keycode: 8594,
    typeof: "basic",
    keyIndex: 96,
  },
  {
    name: "K42",
    type: "基础",
    comm: "键位 42",
    hex16: 0x32,
    keycode: 50,
    typeof: "basic",
    keyIndex: 97,
  },
  {
    name: "K45",
    type: "基础",
    comm: "键位 45",
    hex16: 0x64,
    keycode: 100,
    typeof: "basic",
    keyIndex: 98,
  },
  {
    name: "PRINT",
    type: "基础",
    comm: "打印屏幕",
    hex16: 0x46,
    keycode: 70,
    typeof: "basic",
    keyIndex: 99,
  },
  {
    name: "SCROLL",
    type: "基础",
    comm: "滚动锁定",
    hex16: 0x47,
    keycode: 71,
    typeof: "basic",
    keyIndex: 100,
  },
  {
    name: "WIN_R",
    type: "基础",
    comm: "右 Win",
    hex16: 0xe7,
    keycode: 231,
    typeof: "basic",
    keyIndex: 101,
  },
  {
    name: "PAUSE",
    type: "基础",
    comm: "暂停键",
    hex16: 0x48,
    keycode: 72,
    typeof: "basic",
    keyIndex: 102,
  },
  {
    name: "INSERT",
    type: "基础",
    comm: "插入键",
    hex16: 0x49,
    keycode: 73,
    typeof: "basic",
    keyIndex: 103,
  },
  {
    name: "HOME",
    type: "基础",
    comm: "Home 键",
    hex16: 0x4a,
    keycode: 74,
    typeof: "basic",
    keyIndex: 104,
  },
  {
    name: "PAGEUP",
    type: "基础",
    comm: "上翻页",
    hex16: 0x4b,
    keycode: 75,
    typeof: "basic",
    keyIndex: 105,
  },
  {
    name: "DELETE",
    type: "基础",
    comm: "删除键",
    hex16: 0x4c,
    keycode: 76,
    typeof: "basic",
    keyIndex: 106,
  },
  {
    name: "END",
    type: "基础",
    comm: "End 键",
    hex16: 0x4d,
    keycode: 77,
    typeof: "basic",
    keyIndex: 107,
  },
  {
    name: "PAGEDOWN",
    type: "基础",
    comm: "下翻页",
    hex16: 0x4e,
    keycode: 78,
    typeof: "basic",
    keyIndex: 108,
  },
  {
    name: "PAD-",
    type: "基础",
    comm: "小键盘减号",
    hex16: 0x56,
    keycode: 86,
    typeof: "basic",
    keyIndex: 109,
  },
  {
    name: "PAD+",
    type: "基础",
    comm: "小键盘加号",
    hex16: 0x57,
    keycode: 87,
    typeof: "basic",
    keyIndex: 110,
  },
  {
    name: "SWITCH",
    type: "基础",
    comm: "切换键",
    hex16: null,
    keycode: null,
    typeof: "basic",
    keyIndex: 111,
  },
  {
    name: "K107",
    type: "基础",
    comm: "键位 107",
    hex16: 0x85,
    keycode: 133,
    typeof: "basic",
    keyIndex: 112,
  },
  {
    name: "K56",
    type: "基础",
    comm: "日文 ろ 键",
    hex16: 0x87,
    keycode: 135,
    typeof: "basic",
    keyIndex: 113,
  },
  {
    name: "K14",
    type: "基础",
    comm: "日文 ¥ 键",
    hex16: 0x89,
    keycode: 137,
    typeof: "basic",
    keyIndex: 114,
  },
  {
    name: "K133",
    type: "基础",
    comm: "假名模式",
    hex16: 0x88,
    keycode: 136,
    typeof: "basic",
    keyIndex: 115,
  },
  {
    name: "K132",
    type: "基础",
    comm: "转换键",
    hex16: 0x8a,
    keycode: 138,
    typeof: "basic",
    keyIndex: 116,
  },
  {
    name: "K131",
    type: "基础",
    comm: "无转换键",
    hex16: 0x8b,
    keycode: 139,
    typeof: "basic",
    keyIndex: 117,
  },
  {
    name: "K151",
    type: "基础",
    comm: "键位 151",
    hex16: 0x90,
    keycode: 144,
    typeof: "basic",
    keyIndex: 118,
  },
  {
    name: "K150",
    type: "基础",
    comm: "键位 150",
    hex16: 0x91,
    keycode: 145,
    typeof: "basic",
    keyIndex: 119,
  },
  {
    name: "F13",
    type: "基础",
    comm: "功能键 F13",
    hex16: null,
    keycode: null,
    typeof: "basic",
    keyIndex: 120,
  },
  /** DK108 F 行媒体键：keyIndex 116–118 对应 SDK CONSUMER_KEY param 182/205/181 */
  {
    name: "PREV",
    type: "基础",
    comm: "上一首",
    hex16: null,
    keycode: 8374,
    typeof: "basic",
    keyIndex: 116,
  },
  {
    name: "PLAY",
    type: "基础",
    comm: "播放/暂停",
    hex16: null,
    keycode: 8397,
    typeof: "basic",
    keyIndex: 117,
  },
  {
    name: "NEXT",
    type: "基础",
    comm: "下一首",
    hex16: null,
    keycode: 8373,
    typeof: "basic",
    keyIndex: 118,
  },
];
// 基础按键
export const KEYBOARD_BASIC_MAP_HFD = [
  {
    name: "A",
    hex16: 0x04,
    value16: 4,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x004,
    valuePar2: 4,
    desc: "字母 A",
  },
  {
    name: "B",
    hex16: 0x05,
    value16: 5,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x005,
    valuePar2: 5,
    desc: "字母 B",
  },
  {
    name: "C",
    hex16: 0x06,
    value16: 6,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x006,
    valuePar2: 6,
    desc: "字母 C",
  },
  {
    name: "D",
    hex16: 0x07,
    value16: 7,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x007,
    valuePar2: 7,
    desc: "字母 D",
  },
  {
    name: "E",
    hex16: 0x08,
    value16: 8,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x008,
    valuePar2: 8,
    desc: "字母 E",
  },
  {
    name: "F",
    hex16: 0x09,
    value16: 9,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x009,
    valuePar2: 9,
    desc: "字母 F",
  },
  {
    name: "G",
    hex16: 0x0a,
    value16: 10,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00a,
    valuePar2: 10,
    desc: "字母 G",
  },
  {
    name: "H",
    hex16: 0x0b,
    value16: 11,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00b,
    valuePar2: 11,
    desc: "字母 H",
  },
  {
    name: "I",
    hex16: 0x0c,
    value16: 12,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00c,
    valuePar2: 12,
    desc: "字母 I",
  },
  {
    name: "J",
    hex16: 0x0d,
    value16: 13,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00d,
    valuePar2: 13,
    desc: "字母 J",
  },
  {
    name: "K",
    hex16: 0x0e,
    value16: 14,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00e,
    valuePar2: 14,
    desc: "字母 K",
  },
  {
    name: "L",
    hex16: 0x0f,
    value16: 15,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00f,
    valuePar2: 15,
    desc: "字母 L",
  },
  {
    name: "M",
    hex16: 0x10,
    value16: 16,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x010,
    valuePar2: 16,
    desc: "字母 M",
  },
  {
    name: "N",
    hex16: 0x11,
    value16: 17,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x011,
    valuePar2: 17,
    desc: "字母 N",
  },
  {
    name: "O",
    hex16: 0x12,
    value16: 18,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x012,
    valuePar2: 18,
    desc: "字母 O",
  },
  {
    name: "P",
    hex16: 0x13,
    value16: 19,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x013,
    valuePar2: 19,
    desc: "字母 P",
  },
  {
    name: "Q",
    hex16: 0x14,
    value16: 20,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x014,
    valuePar2: 20,
    desc: "字母 Q",
  },
  {
    name: "R",
    hex16: 0x15,
    value16: 21,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x015,
    valuePar2: 21,
    desc: "字母 R",
  },
  {
    name: "S",
    hex16: 0x16,
    value16: 22,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x016,
    valuePar2: 22,
    desc: "字母 S",
  },
  {
    name: "T",
    hex16: 0x17,
    value16: 23,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x017,
    valuePar2: 23,
    desc: "字母 T",
  },
  {
    name: "U",
    hex16: 0x18,
    value16: 24,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x018,
    valuePar2: 24,
    desc: "字母 U",
  },
  {
    name: "V",
    hex16: 0x19,
    value16: 25,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x019,
    valuePar2: 25,
    desc: "字母 V",
  },
  {
    name: "W",
    hex16: 0x1a,
    value16: 26,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x01a,
    valuePar2: 26,
    desc: "字母 W",
  },
  {
    name: "X",
    hex16: 0x1b,
    value16: 27,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x01b,
    valuePar2: 27,
    desc: "字母 X",
  },
  {
    name: "Y",
    hex16: 0x1c,
    value16: 28,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x01c,
    valuePar2: 28,
    desc: "字母 Y",
  },
  {
    name: "Z",
    hex16: 0x1d,
    value16: 29,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x01d,
    valuePar2: 29,
    desc: "字母 Z",
  },
  {
    name: "1 !",
    hex16: 0x1e,
    value16: 30,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x01e,
    valuePar2: 30,
    desc: "数字 1 / 感叹号",
  },
  {
    name: "2 @",
    hex16: 0x1f,
    value16: 31,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x01f,
    valuePar2: 31,
    desc: "数字 2 / @",
  },
  {
    name: "3 #",
    hex16: 0x20,
    value16: 32,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x020,
    valuePar2: 32,
    desc: "数字 3 / #",
  },
  {
    name: "4 $",
    hex16: 0x21,
    value16: 33,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x021,
    valuePar2: 33,
    desc: "数字 4 / $",
  },
  {
    name: "5 %",
    hex16: 0x22,
    value16: 34,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x022,
    valuePar2: 34,
    desc: "数字 5 / %",
  },
  {
    name: "6 ^",
    hex16: 0x23,
    value16: 35,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x023,
    valuePar2: 35,
    desc: "数字 6 / ^",
  },
  {
    name: "7 &",
    hex16: 0x24,
    value16: 36,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x024,
    valuePar2: 36,
    desc: "数字 7 / &",
  },
  {
    name: "8*",
    hex16: 0x25,
    value16: 37,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x025,
    valuePar2: 37,
    desc: "数字 8 /*",
  },
  {
    name: "9 (",
    hex16: 0x26,
    value16: 38,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x026,
    valuePar2: 38,
    desc: "数字 9 / (",
  },
  {
    name: "0 )",
    hex16: 0x27,
    value16: 39,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x027,
    valuePar2: 39,
    desc: "数字 0 / )",
  },
  {
    name: "ˉ -",
    hex16: 0x2d,
    value16: 45,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x02d,
    valuePar2: 45,
    desc: "减号 / 下划线",
  },
  {
    name: "= +",
    hex16: 0x2e,
    value16: 46,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x02e,
    valuePar2: 46,
    desc: "等号 / 加号",
  },
  {
    name: "[ {",
    hex16: 0x2f,
    value16: 47,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x02f,
    valuePar2: 47,
    desc: "左方括号 / {",
  },
  {
    name: "] }",
    hex16: 0x30,
    value16: 48,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x030,
    valuePar2: 48,
    desc: "右方括号 / }",
  },
  {
    name: "\\ |",
    hex16: 0x31,
    value16: 49,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x031,
    valuePar2: 49,
    desc: "反斜杠 / 竖线",
  },
  {
    name: "; :",
    hex16: 0x33,
    value16: 51,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x033,
    valuePar2: 51,
    desc: "分号 / 冒号",
  },
  {
    name: "' \"",
    hex16: 0x34,
    value16: 52,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x034,
    valuePar2: 52,
    desc: "单引号 / 双引号",
  },
  {
    name: "` ~",
    hex16: 0x35,
    value16: 53,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x035,
    valuePar2: 53,
    desc: "反引号 / 波浪号",
  },
  {
    name: ",<",
    hex16: 0x36,
    value16: 54,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x036,
    valuePar2: 54,
    desc: "逗号 / <",
  },
  {
    name: ".>",
    hex16: 0x37,
    value16: 55,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x037,
    valuePar2: 55,
    desc: "句号 / >",
  },
  {
    name: "/?",
    hex16: 0x38,
    value16: 56,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x038,
    valuePar2: 56,
    desc: "斜杠 / ?",
  },
];

// 扩展按键
export const KEYBOARD_EXTEND_MAP_HFD = [
  {
    name: "Fn",
    hex16: 0xf101,
    value16: 61697,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xaf,
    valuePar2: 175,
    desc: "FN 键",
  },
  {
    name: "Esc",
    hex16: "0x29",
    value16: 41,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: "0x29",
    valuePar2: 41,
    desc: "退出键",
  },
  {
    name: "Tab",
    hex16: 0x2b,
    value16: 43,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x2b,
    valuePar2: 43,
    desc: "制表键",
  },
  {
    name: "Caps",
    hex16: 0x39,
    value16: 57,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x39,
    valuePar2: 57,
    desc: "大写锁定",
  },
  {
    name: "Back space",
    hex16: 0x2a,
    value16: 42,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x2a,
    valuePar2: 42,
    desc: "退格键",
  },
  {
    name: "Enter",
    hex16: 0x28,
    value16: 40,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x28,
    valuePar2: 40,
    desc: "回车键",
  },
  {
    name: "Space Bar",
    hex16: 0x2c,
    value16: 44,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x2c,
    valuePar2: 44,
    desc: "空格键",
  },
  {
    name: "L-Ctrl",
    hex16: 0xe0,
    value16: 224,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe0,
    valuePar2: 224,
    desc: "左 Ctrl",
  },
  {
    name: "R-Ctrl",
    hex16: 0xe4,
    value16: 228,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe4,
    valuePar2: 228,
    desc: "右 Ctrl",
  },
  {
    name: "L-Shift",
    hex16: 0xe1,
    value16: 225,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe1,
    valuePar2: 225,
    desc: "左 Shift",
  },
  {
    name: "R-Shift",
    hex16: 0xe5,
    value16: 229,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe5,
    valuePar2: 229,
    desc: "右 Shift",
  },
  {
    name: "L-Alt",
    hex16: 0xe2,
    value16: 226,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe2,
    valuePar2: 226,
    desc: "左 Alt",
  },
  {
    name: "R-Alt",
    hex16: 0xe6,
    value16: 230,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe6,
    valuePar2: 230,
    desc: "右 Alt",
  },
  {
    name: "L-Win",
    hex16: 0xe3,
    value16: 227,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe3,
    valuePar2: 227,
    desc: "左 Win/Cmd",
  },
  {
    name: "R-Win",
    hex16: 0xe7,
    value16: 231,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0xe7,
    valuePar2: 231,
    desc: "右 Win/Cmd",
  },
  {
    name: "Menu",
    hex16: 0x65,
    value16: 101,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x65,
    valuePar2: 101,
    desc: "菜单键",
  },
  {
    name: "↑",
    hex16: 0x52,
    value16: 82,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x52,
    valuePar2: 82,
    desc: "上箭头",
  },
  {
    name: "↓",
    hex16: 0x51,
    value16: 81,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x51,
    valuePar2: 81,
    desc: "下箭头",
  },
  {
    name: "→",
    hex16: 0x4f,
    value16: 79,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x4f,
    valuePar2: 79,
    desc: "右箭头",
  },
  {
    name: "←",
    hex16: 0x50,
    value16: 80,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x50,
    valuePar2: 80,
    desc: "左箭头",
  },
  {
    name: "Home",
    hex16: 0x4a,
    value16: 74,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x4a,
    valuePar2: 74,
    desc: "Home 键",
  },
  {
    name: "End",
    hex16: 0x4d,
    value16: 77,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x4d,
    valuePar2: 77,
    desc: "End 键",
  },
  {
    name: "Ins",
    hex16: 0x49,
    value16: 73,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x49,
    valuePar2: 73,
    desc: "插入键",
  },
  {
    name: "Del",
    hex16: 0x4c,
    value16: 76,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x4c,
    valuePar2: 76,
    desc: "删除键",
  },
  {
    name: "PgUp",
    hex16: 0x4b,
    value16: 75,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x4b,
    valuePar2: 75,
    desc: "上翻页",
  },
  {
    name: "PgDn",
    hex16: 0x4e,
    value16: 78,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x4e,
    valuePar2: 78,
    desc: "下翻页",
  },
  {
    name: "Print",
    hex16: 0x46,
    value16: 70,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x46,
    valuePar2: 70,
    desc: "打印屏幕",
  },
  {
    name: "Scroll",
    hex16: 0x47,
    value16: 71,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x47,
    valuePar2: 71,
    desc: "滚动锁定",
  },
  {
    name: "Pause",
    hex16: 0x48,
    value16: 72,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x48,
    valuePar2: 72,
    desc: "暂停键",
  },
  {
    name: "F1",
    hex16: 0x3a,
    value16: 58,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x3a,
    valuePar2: 58,
    desc: "功能键 F1",
  },
  {
    name: "F2",
    hex16: 0x3b,
    value16: 59,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x3b,
    valuePar2: 59,
    desc: "功能键 F2",
  },
  {
    name: "F3",
    hex16: 0x3c,
    value16: 60,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x3c,
    valuePar2: 60,
    desc: "功能键 F3",
  },
  {
    name: "F4",
    hex16: 0x3d,
    value16: 61,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x3d,
    valuePar2: 61,
    desc: "功能键 F4",
  },
  {
    name: "F5",
    hex16: 0x3e,
    value16: 62,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x3e,
    valuePar2: 62,
    desc: "功能键 F5",
  },
  {
    name: "F6",
    hex16: 0x3f,
    value16: 63,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x3f,
    valuePar2: 63,
    desc: "功能键 F6",
  },
  {
    name: "F7",
    hex16: 0x40,
    value16: 64,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x40,
    valuePar2: 64,
    desc: "功能键 F7",
  },
  {
    name: "F8",
    hex16: 0x41,
    value16: 65,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x41,
    valuePar2: 65,
    desc: "功能键 F8",
  },
  {
    name: "F9",
    hex16: 0x42,
    value16: 66,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x42,
    valuePar2: 66,
    desc: "功能键 F9",
  },
  {
    name: "F10",
    hex16: 0x43,
    value16: 67,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x43,
    valuePar2: 67,
    desc: "功能键 F10",
  },
  {
    name: "F11",
    hex16: 0x44,
    value16: 68,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x44,
    valuePar2: 68,
    desc: "功能键 F11",
  },
  {
    name: "F12",
    hex16: 0x45,
    value16: 69,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x45,
    valuePar2: 69,
    desc: "功能键 F12",
  },
  {
    name: "Num Lock",
    hex16: 0x53,
    value16: 83,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x53,
    valuePar2: 83,
    desc: "数字锁定",
  },
  {
    name: "Num 1",
    hex16: 0x59,
    value16: 89,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x59,
    valuePar2: 89,
    desc: "小键盘 1",
  },
  {
    name: "Num 2",
    hex16: 0x5a,
    value16: 90,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x5a,
    valuePar2: 90,
    desc: "小键盘 2",
  },
  {
    name: "Num 3",
    hex16: 0x5b,
    value16: 91,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x5b,
    valuePar2: 91,
    desc: "小键盘 3",
  },
  {
    name: "Num 4",
    hex16: 0x5c,
    value16: 92,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x5c,
    valuePar2: 92,
    desc: "小键盘 4",
  },
  {
    name: "Num 5",
    hex16: 0x5d,
    value16: 93,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x5d,
    valuePar2: 93,
    desc: "小键盘 5",
  },
  {
    name: "Num 6",
    hex16: 0x5e,
    value16: 94,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x5e,
    valuePar2: 94,
    desc: "小键盘 6",
  },
  {
    name: "Num 7",
    hex16: 0x5f,
    value16: 95,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x5f,
    valuePar2: 95,
    desc: "小键盘 7",
  },
  {
    name: "Num 8",
    hex16: 0x60,
    value16: 96,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x60,
    valuePar2: 96,
    desc: "小键盘 8",
  },
  {
    name: "Num 9",
    hex16: 0x61,
    value16: 97,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x61,
    valuePar2: 97,
    desc: "小键盘 9",
  },
  {
    name: "Num 0",
    hex16: 0x62,
    value16: 98,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x62,
    valuePar2: 98,
    desc: "小键盘 0",
  },
  {
    name: "Num /",
    hex16: 0x54,
    value16: 84,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x54,
    valuePar2: 84,
    desc: "小键盘除号",
  },
  {
    name: "Num .",
    hex16: 0x63,
    value16: 99,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x63,
    valuePar2: 99,
    desc: "小键盘小数点",
  },
  {
    name: "Num*",
    hex16: 0x55,
    value16: 85,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x55,
    valuePar2: 85,
    desc: "小键盘乘号",
  },
  {
    name: "Num -",
    hex16: 0x56,
    value16: 86,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x56,
    valuePar2: 86,
    desc: "小键盘减号",
  },
  {
    name: "Num +",
    hex16: 0x57,
    value16: 87,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x57,
    valuePar2: 87,
    desc: "小键盘加号",
  },
  {
    name: "Num Enter",
    hex16: 0x58,
    value16: 88,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x58,
    valuePar2: 88,
    desc: "小键盘回车",
  },
  {
    name: "⊠",
    hex16: 0x6b,
    value16: 107,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x6b,
    valuePar2: 107,
    desc: "禁用按键",
  },
];
// 鼠标按键
export const MOUSE_MAP_HFD = [
  {
    name: "鼠标左键",
    hex16: 0x01,
    value16: 1,
    page: "MOUSE",
    param1: 0x01,
    valuePar1: 1,
    param2: 0x001,
    valuePar2: 1,
    desc: "鼠标左键点击",
    xsKeycode: 16640,
  },
  {
    name: "鼠标中键",
    hex16: 0x04,
    value16: 4,
    page: "MOUSE",
    param1: 0x01,
    valuePar1: 1,
    param2: 0x004,
    valuePar2: 4,
    desc: "鼠标中键点击",
    xsKeycode: 17152,
  },
  {
    name: "鼠标右键",
    hex16: 0x02,
    value16: 2,
    page: "MOUSE",
    param1: 0x01,
    valuePar1: 1,
    param2: 0x002,
    valuePar2: 2,
    desc: "鼠标右键点击",
    xsKeycode: 16896,
  },
  {
    name: "鼠标向上滚动",
    hex16: 0x01,
    value16: 1,
    page: "MOUSE",
    param1: 0x03,
    valuePar1: 3,
    param2: 0x001,
    valuePar2: 1,
    desc: "滚轮向上滚动",
    xsKeycode: 18945,
  },
  {
    name: "鼠标向下滚动",
    hex16: 0xff,
    value16: 255,
    page: "MOUSE",
    param1: 0x03,
    valuePar1: 3,
    param2: 0x0ff,
    valuePar2: 255,
    desc: "滚轮向下滚动",
    xsKeycode: 19201,
  },
  {
    name: "鼠标前进键",
    hex16: 0x10,
    value16: 16,
    page: "MOUSE",
    param1: 0x01,
    valuePar1: 1,
    param2: 0x010,
    valuePar2: 16,
    desc: "鼠标侧键前进",
    xsKeycode: 17408,
  },
  {
    name: "鼠标后退键",
    hex16: 0x08,
    value16: 8,
    page: "MOUSE",
    param1: 0x01,
    valuePar1: 1,
    param2: 0x008,
    valuePar2: 8,
    desc: "鼠标侧键后退",
    xsKeycode: 17664,
  },
];
// 设备按键
export const CONSUMER_MAP_HFD = [
  {
    name: "我的电脑",
    hex16: 0x194,
    value16: 404,
    page: "CONSUMER_KEY",
    param1: 0x94,
    valuePar1: 148,
    param2: 0x01,
    valuePar2: 1,
    desc: "打开我的电脑",
    xsKeycode: 8596,
  },
  {
    name: "计算器",
    hex16: 0x192,
    value16: 402,
    page: "CONSUMER_KEY",
    param1: 0x92,
    valuePar1: 146,
    param2: 0x01,
    valuePar2: 1,
    desc: "打开计算器",
    xsKeycode: 8594,
  },
  {
    name: "邮箱",
    hex16: 0x18a,
    value16: 394,
    page: "CONSUMER_KEY",
    param1: 0x8a,
    valuePar1: 138,
    param2: 0x01,
    valuePar2: 1,
    desc: "打开邮箱",
  },
  {
    name: "多媒体",
    hex16: 0x183,
    value16: 387,
    page: "CONSUMER_KEY",
    param1: 0x83,
    valuePar1: 131,
    param2: 0x01,
    valuePar2: 1,
    desc: "打开多媒体",
    xsKeycode: 8579,
  },
  {
    name: "播放/暂停",
    hex16: 0xcd,
    value16: 205,
    page: "CONSUMER_KEY",
    param1: 0xcd,
    valuePar1: 205,
    param2: 0x00,
    valuePar2: 0,
    desc: "播放或暂停媒体",
    xsKeycode: 8397,
  },
  {
    name: "播放停止",
    hex16: 0xb7,
    value16: 183,
    page: "CONSUMER_KEY",
    param1: 0xb7,
    valuePar1: 183,
    param2: 0x00,
    valuePar2: 0,
    desc: "停止播放",
    xsKeycode: 8375,
  },
  {
    name: "上一首",
    hex16: 0xb6,
    value16: 182,
    page: "CONSUMER_KEY",
    param1: 0xb6,
    valuePar1: 182,
    param2: 0x00,
    valuePar2: 0,
    desc: "上一曲",
    xsKeycode: 8374,
  },
  {
    name: "下一首",
    hex16: 0xb5,
    value16: 181,
    page: "CONSUMER_KEY",
    param1: 0xb5,
    valuePar1: 181,
    param2: 0x00,
    valuePar2: 0,
    desc: "下一曲",
    xsKeycode: 8373,
  },
  {
    name: "音量 +",
    hex16: 0xe9,
    value16: 233,
    page: "CONSUMER_KEY",
    param1: 0xe9,
    valuePar1: 233,
    param2: 0x00,
    valuePar2: 0,
    desc: "增加音量",
    xsKeycode: 8425,
  },
  {
    name: "音量 -",
    hex16: 0xea,
    value16: 234,
    page: "CONSUMER_KEY",
    param1: 0xea,
    valuePar1: 234,
    param2: 0x00,
    valuePar2: 0,
    desc: "减少音量",
    xsKeycode: 8426,
  },
  {
    name: "静音",
    hex16: 0xe2,
    value16: 226,
    page: "CONSUMER_KEY",
    param1: 0xe2,
    valuePar1: 226,
    param2: 0x00,
    valuePar2: 0,
    desc: "静音/取消静音",
    xsKeycode: 8418,
  },
  {
    name: "主页",
    hex16: 0x223,
    value16: 547,
    page: "CONSUMER_KEY",
    param1: 0x23,
    valuePar1: 35,
    param2: 0x02,
    valuePar2: 2,
    desc: "浏览器主页",
  },
  {
    name: "刷新",
    hex16: 0x227,
    value16: 551,
    page: "CONSUMER_KEY",
    param1: 0x27,
    valuePar1: 39,
    param2: 0x02,
    valuePar2: 2,
    desc: "刷新页面",
  },
  {
    name: "前进",
    hex16: 0x225,
    value16: 549,
    page: "CONSUMER_KEY",
    param1: 0x25,
    valuePar1: 37,
    param2: 0x02,
    valuePar2: 2,
    desc: "浏览器前进",
  },
  {
    name: "后退",
    hex16: 0x224,
    value16: 548,
    page: "CONSUMER_KEY",
    param1: 0x24,
    valuePar1: 36,
    param2: 0x02,
    valuePar2: 2,
    desc: "浏览器后退",
  },
  {
    name: "收藏",
    hex16: 0x22a,
    value16: 554,
    page: "CONSUMER_KEY",
    param1: 0x2a,
    valuePar1: 42,
    param2: 0x02,
    valuePar2: 2,
    desc: "添加收藏",
  },
  {
    name: "搜索",
    hex16: 0x221,
    value16: 545,
    page: "CONSUMER_KEY",
    param1: 0x21,
    valuePar1: 33,
    param2: 0x02,
    valuePar2: 2,
    desc: "打开搜索",
  },
];
// 功能按键
export const FUNC_MAP_HFD = [
  {
    name: "恢复出厂设置",
    hex16: 0x01,
    value16: 1,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x01,
    valuePar3: 1,
    desc: "长按",
    xsKeycode: 61952,
  },
  {
    name: "蓝牙通道 1",
    hex16: 0x02,
    value16: 2,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x02,
    valuePar3: 2,
    desc: "短按",
  },
  {
    name: "蓝牙通道 2",
    hex16: 0x03,
    value16: 3,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x03,
    valuePar3: 3,
    desc: "短按",
  },
  {
    name: "蓝牙通道 3",
    hex16: 0x04,
    value16: 4,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x04,
    valuePar3: 4,
    desc: "短按",
  },
  {
    name: "无线回连",
    hex16: 0x05,
    value16: 5,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x05,
    valuePar3: 5,
    desc: "短按",
  },
  {
    name: "F 区转换",
    hex16: 0x06,
    value16: 6,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x06,
    valuePar3: 6,
    desc: "短按",
  },
  {
    name: "查询电量",
    hex16: 0x07,
    value16: 7,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x07,
    valuePar3: 7,
    desc: "短按",
  },
  {
    name: "WIN",
    hex16: 0x08,
    value16: 8,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x08,
    valuePar3: 8,
    desc: "短按",
    xsKeycode: 61953,
  },
  {
    name: "MAC",
    hex16: 0x09,
    value16: 9,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x09,
    valuePar3: 9,
    desc: "短按",
    xsKeycode: 61954,
  },
  {
    name: "ANDROID",
    hex16: 0x0a,
    value16: 10,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x0a,
    valuePar3: 10,
    desc: "短按",
  },
  {
    name: "灯光效果切换",
    hex16: 0x0b,
    value16: 11,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x0b,
    valuePar3: 11,
    desc: "短按",
    xsKeycode: 62208,
  },
  {
    name: "灯光颜色切换",
    hex16: 0x0c,
    value16: 12,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x0c,
    valuePar3: 12,
    desc: "短按",
    xsKeycode: 62209,
  },
  {
    name: "灯光亮度+",
    hex16: 0x0d,
    value16: 13,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x0d,
    valuePar3: 13,
    desc: "短按",
    xsKeycode: 62210,
  },
  {
    name: "灯光亮度-",
    hex16: 0x0e,
    value16: 14,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x0e,
    valuePar3: 14,
    desc: "短按",
    xsKeycode: 62211,
  },
  {
    name: "灯光速度+",
    hex16: 0x0f,
    value16: 15,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x0f,
    valuePar3: 15,
    desc: "短按",
    xsKeycode: 62212,
  },
  {
    name: "灯光速度-",
    hex16: 0x10,
    value16: 16,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x10,
    valuePar3: 16,
    desc: "短按",
    xsKeycode: 62213,
  },
  {
    name: "关闭灯光",
    hex16: 0x11,
    value16: 17,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x11,
    valuePar3: 17,
    desc: "短按",
    xsKeycode: 62215,
  },
  {
    name: "ALT + TAB",
    hex16: 0x12,
    value16: 18,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x12,
    valuePar3: 18,
    desc: "短按",
  },
  {
    name: "WIN + E",
    hex16: 0x13,
    value16: 19,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x13,
    valuePar3: 19,
    desc: "短按",
  },
  {
    name: "WIN + TAB",
    hex16: 0x14,
    value16: 20,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x14,
    valuePar3: 20,
    desc: "短按",
  },
  {
    name: "WIN + H",
    hex16: 0x15,
    value16: 21,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x15,
    valuePar3: 21,
    desc: "短按",
  },
  {
    name: "锁定 Win",
    hex16: 0x16,
    value16: 22,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x16,
    valuePar3: 22,
    desc: "短按",
  },
  {
    name: "侧灯效果切换",
    hex16: 0x17,
    value16: 23,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x17,
    valuePar3: 23,
    desc: "短按",
    xsKeycode: 62240,
  },
  {
    name: "侧灯颜色切换",
    hex16: 0x18,
    value16: 24,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x18,
    valuePar3: 24,
    desc: "短按",
    xsKeycode: 62241,
  },
  {
    name: "侧灯亮度调节",
    hex16: 0x19,
    value16: 25,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x19,
    valuePar3: 25,
    desc: "短按",
    xsKeycode: 62242,
  },
  {
    name: "侧灯速度调节",
    hex16: 0x1a,
    value16: 26,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x1a,
    valuePar3: 26,
    desc: "短按",
    xsKeycode: 62244,
  },
  {
    name: "正面灯条效果切换",
    hex16: 0x1b,
    value16: 27,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x1b,
    valuePar3: 27,
    desc: "短按",
    xsKeycode: 62224,
  },
  {
    name: "正面灯条速度调节",
    hex16: 0x1c,
    value16: 28,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x1c,
    valuePar3: 28,
    desc: "短按",
    xsKeycode: 62226,
  },
  {
    name: "正面灯条颜色切换",
    hex16: 0x1d,
    value16: 29,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x1d,
    valuePar3: 29,
    desc: "短按",
    xsKeycode: 62225,
  },
  {
    name: "Ctrl + UP",
    hex16: 0x1e,
    value16: 30,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x1e,
    valuePar3: 30,
    desc: "短按",
  },
  {
    name: "USB 模式",
    hex16: 0x1f,
    value16: 31,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x1f,
    valuePar3: 31,
    desc: "短按",
  },
  {
    name: "灯效方向",
    hex16: 0x20,
    value16: 32,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x20,
    valuePar3: 32,
    desc: "短按",
    xsKeycode: 62216,
  },
  {
    name: "ALT + ESC",
    hex16: 0x21,
    value16: 33,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x21,
    valuePar3: 33,
    desc: "短按",
  },
  {
    name: "SHIFT + GAT",
    hex16: 0x22,
    value16: 34,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x22,
    valuePar3: 34,
    desc: "短按",
  },
  {
    name: "屏幕左切",
    hex16: 0x23,
    value16: 35,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x23,
    valuePar3: 35,
    desc: "短按",
  },
  {
    name: "屏幕右切",
    hex16: 0x24,
    value16: 36,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x24,
    valuePar3: 36,
    desc: "短按",
  },
  {
    name: "屏幕确认",
    hex16: 0x25,
    value16: 37,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x25,
    valuePar3: 37,
    desc: "短按",
  },
  {
    name: "测试灯光",
    hex16: 0x26,
    value16: 38,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x26,
    valuePar3: 38,
    desc: "短按",
  },
  {
    name: "关闭屏幕",
    hex16: 0x27,
    value16: 39,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x27,
    valuePar3: 39,
    desc: "短按",
  },
  {
    name: "点阵屏灯效切换",
    hex16: 0x28,
    value16: 40,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x28,
    valuePar3: 40,
    desc: "短按",
  },
  {
    name: "点阵屏亮度+",
    hex16: 0x29,
    value16: 41,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x29,
    valuePar3: 41,
    desc: "短按",
  },
  {
    name: "点阵屏亮度-",
    hex16: 0x2a,
    value16: 42,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x2a,
    valuePar3: 42,
    desc: "短按",
  },
  {
    name: "点阵屏速度-",
    hex16: 0x2b,
    value16: 43,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x2b,
    valuePar3: 43,
    desc: "短按",
  },
  {
    name: "点阵屏速度+",
    hex16: 0x2c,
    value16: 44,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x2c,
    valuePar3: 44,
    desc: "短按",
  },
  {
    name: "单键全键无线唤醒开关",
    hex16: 0x2d,
    value16: 45,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x2d,
    valuePar3: 45,
    desc: "短按",
  },
  {
    name: "旋钮模式切换",
    hex16: 0x2e,
    value16: 46,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x2e,
    valuePar3: 46,
    desc: "短按",
  },
  {
    name: "WIN + X",
    hex16: 0x2f,
    value16: 47,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x2f,
    valuePar3: 47,
    desc: "短按",
  },
  {
    name: "CTAL_CAP 调换",
    hex16: 0x30,
    value16: 48,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x30,
    valuePar3: 48,
    desc: "长按",
  },
  {
    name: "屏蔽/打开驱动设置",
    hex16: 0x31,
    value16: 49,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x31,
    valuePar3: 49,
    desc: "短按",
  },
  {
    name: "CTRL+下",
    hex16: 0x32,
    value16: 50,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x32,
    valuePar3: 50,
    desc: "短按",
  },
  {
    name: "灯光效果正向切换",
    hex16: 0x33,
    value16: 51,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x33,
    valuePar3: 51,
    desc: "短按",
  },
  {
    name: "灯光效果反向切换",
    hex16: 0x34,
    value16: 52,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x34,
    valuePar3: 52,
    desc: "短按",
  },
  {
    name: "WIN + D",
    hex16: 0x35,
    value16: 53,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x35,
    valuePar3: 53,
    desc: "短按",
  },
  {
    name: "拾音灯颜色切换",
    hex16: 0x36,
    value16: 54,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x36,
    valuePar3: 54,
    desc: "短按",
  },
  {
    name: "拾音灯模式切换",
    hex16: 0x37,
    value16: 55,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x37,
    valuePar3: 55,
    desc: "短按",
  },
  {
    name: "拾音灯开关",
    hex16: 0x38,
    value16: 56,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x38,
    valuePar3: 56,
    desc: "短按",
  },
  {
    name: "Home",
    hex16: 0x39,
    value16: 57,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x39,
    valuePar3: 57,
    desc: "短按",
  },
  {
    name: "IOS",
    hex16: 0x3a,
    value16: 58,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x3a,
    valuePar3: 58,
    desc: "短按",
  },
  {
    name: "点阵屏测试模式",
    hex16: 0x3b,
    value16: 59,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x3b,
    valuePar3: 59,
    desc: "短按",
  },
  {
    name: "点阵屏测试颜色",
    hex16: 0x3c,
    value16: 60,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x3c,
    valuePar3: 60,
    desc: "短按",
  },
  {
    name: "正面灯条亮度切换",
    hex16: 0x3d,
    value16: 61,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x3d,
    valuePar3: 61,
    desc: "短按",
  },
  {
    name: "点阵屏开关",
    hex16: 0x3e,
    value16: 62,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x3e,
    valuePar3: 62,
    desc: "短按",
  },
  {
    name: "GIF 模式",
    hex16: 0x3f,
    value16: 63,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x3f,
    valuePar3: 63,
    desc: "短按",
  },
  {
    name: "正面灯条速度+",
    hex16: 0x40,
    value16: 64,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x40,
    valuePar3: 64,
    desc: "短按",
  },
  {
    name: "正面灯条速度-",
    hex16: 0x41,
    value16: 65,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x41,
    valuePar3: 65,
    desc: "短按",
  },
  {
    name: "正面灯条亮度+",
    hex16: 0x42,
    value16: 66,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x42,
    valuePar3: 66,
    desc: "短按",
  },
  {
    name: "正面灯条亮度-",
    hex16: 0x43,
    value16: 67,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x43,
    valuePar3: 67,
    desc: "短按",
  },
  {
    name: "屏蔽/开启按键快捷指令-",
    hex16: 0x44,
    value16: 68,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x44,
    valuePar3: 68,
    desc: "短按",
  },
  {
    name: "蓝牙通道 4",
    hex16: 0x45,
    value16: 69,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x45,
    valuePar3: 69,
    desc: "短按",
  },
  {
    name: "蓝牙通道 5",
    hex16: 0x46,
    value16: 70,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x46,
    valuePar3: 70,
    desc: "短按",
  },
  {
    name: "自定义灯光 1",
    hex16: 0x47,
    value16: 71,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x47,
    valuePar3: 71,
    desc: "短按",
  },
  {
    name: "自定义灯光 2",
    hex16: 0x48,
    value16: 72,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x48,
    valuePar3: 72,
    desc: "短按",
  },
  {
    name: "开启/关闭极致省电",
    hex16: 0x49,
    value16: 73,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x49,
    valuePar3: 73,
    desc: "短按",
  },
  {
    name: "侧灯色块颜色",
    hex16: 0x4a,
    value16: 74,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x4a,
    valuePar3: 74,
    desc: "短按",
  },
  {
    name: "打开驱动",
    hex16: 0x4b,
    value16: 75,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x4b,
    valuePar3: 75,
    desc: "短按",
  },
  {
    name: "0.1/0.01RT 精度切换",
    hex16: 0x4c,
    value16: 76,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x4c,
    valuePar3: 76,
    desc: "短按",
  },
  {
    name: "灯效上下灯位开关",
    hex16: 0x4d,
    value16: 77,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x4d,
    valuePar3: 77,
    desc: "短按",
  },
  {
    name: "切换灯效方向",
    hex16: 0x4e,
    value16: 78,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x4e,
    valuePar3: 78,
    desc: "短按",
  },
  {
    name: "方向键转换",
    hex16: 0x4f,
    value16: 79,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x4f,
    valuePar3: 79,
    desc: "短按",
  },
  {
    name: "背光亮度循环切换",
    hex16: 0x50,
    value16: 80,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x50,
    valuePar3: 80,
    desc: "短按",
  },
  {
    name: "背光速度循环切换",
    hex16: 0x51,
    value16: 81,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x51,
    valuePar3: 81,
    desc: "短按",
  },
  {
    name: "切换 USB 模式",
    hex16: 0x52,
    value16: 82,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x52,
    valuePar3: 82,
    desc: "短按",
  },
  {
    name: "关闭后侧灯、前灯条",
    hex16: 0x53,
    value16: 83,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x53,
    valuePar3: 83,
    desc: "短按",
  },
  {
    name: "显示屏语言切换为汉语",
    hex16: 0x54,
    value16: 84,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x54,
    valuePar3: 84,
    desc: "短按",
  },
  {
    name: "显示屏语言切换为英语",
    hex16: 0x55,
    value16: 85,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x55,
    valuePar3: 85,
    desc: "短按",
  },
  {
    name: "CTRL + SPACEBAR",
    hex16: 0x56,
    value16: 86,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x56,
    valuePar3: 86,
    desc: "短按",
  },
  {
    name: "侧灯 RT 深度灯效",
    hex16: 0x57,
    value16: 87,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x57,
    valuePar3: 87,
    desc: "短按",
  },
  {
    name: "WIN + SPACEBAR",
    hex16: 0x58,
    value16: 88,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x58,
    valuePar3: 88,
    desc: "短按",
  },
  {
    name: "LOGO LED ON/OFF",
    hex16: 0x59,
    value16: 89,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x59,
    valuePar3: 89,
    desc: "短按",
  },
  {
    name: "切换点阵屏颜色",
    hex16: 0x5a,
    value16: 90,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x5a,
    valuePar3: 90,
    desc: "短按",
  },
  {
    name: "灯条叠加模式",
    hex16: 0x5b,
    value16: 91,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x5b,
    valuePar3: 91,
    desc: "短按",
  },
  {
    name: "ALT + SPACEBAR",
    hex16: 0x5c,
    value16: 92,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x5c,
    valuePar3: 92,
    desc: "短按",
  },
  {
    name: "一键白光",
    hex16: 0x5d,
    value16: 93,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x5d,
    valuePar3: 93,
    desc: "短按",
  },
  {
    name: "截屏 WIN+SHF+S",
    hex16: 0x5e,
    value16: 94,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x5e,
    valuePar3: 94,
    desc: "短按",
  },
  {
    name: "开启/关闭 APM 计数",
    hex16: 0x5f,
    value16: 95,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x5f,
    valuePar3: 95,
    desc: "长按",
  },
  {
    name: "开启/关闭极致省电",
    hex16: 0x60,
    value16: 96,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x60,
    valuePar3: 96,
    desc: "长按",
  },
  {
    name: "一键进入动图",
    hex16: 0x61,
    value16: 97,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x61,
    valuePar3: 97,
    desc: "短按",
  },
  {
    name: "自定义灯光 3",
    hex16: 0x62,
    value16: 98,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x62,
    valuePar3: 98,
    desc: "短按",
  },
  {
    name: "自定义灯光录制",
    hex16: 0x63,
    value16: 99,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x63,
    valuePar3: 99,
    desc: "短按",
  },
  {
    name: "LOGO 灯切换",
    hex16: 0x64,
    value16: 100,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x64,
    valuePar3: 100,
    desc: "短按",
  },
  {
    name: "8K 数据测试",
    hex16: 0x65,
    value16: 101,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x65,
    valuePar3: 101,
    desc: "长按",
  },
  {
    name: "SOCD 功能开关",
    hex16: 0x66,
    value16: 102,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x66,
    valuePar3: 102,
    desc: "短按",
  },
  {
    name: "灯光效果复位",
    hex16: 0x67,
    value16: 103,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x67,
    valuePar3: 103,
    desc: "短按",
  },
  {
    name: "主灯效/侧灯效亮度加",
    hex16: 0x68,
    value16: 104,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x68,
    valuePar3: 104,
    desc: "短按/侧灯需+ALT-R",
  },
  {
    name: "主灯效/侧灯效亮度减",
    hex16: 0x69,
    value16: 105,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x69,
    valuePar3: 105,
    desc: "短按/侧灯需+ALT-R",
  },
  {
    name: "主灯效/侧灯效速度加",
    hex16: 0x6a,
    value16: 106,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x6a,
    valuePar3: 106,
    desc: "短按/侧灯需+ALT-R",
  },
  {
    name: "主灯效/侧灯效速度减",
    hex16: 0x6b,
    value16: 107,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x6b,
    valuePar3: 107,
    desc: "短按/侧灯需+ALT-R",
  },
  {
    name: "频点测试",
    hex16: 0x6c,
    value16: 108,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x6c,
    valuePar3: 108,
    desc: "长按",
  },
  {
    name: "WIN->MAC 来回切换",
    hex16: 0x6d,
    value16: 109,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x6d,
    valuePar3: 109,
    desc: "长按",
  },
  {
    name: "侧灯亮度+",
    hex16: 0x6e,
    value16: 110,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x6e,
    valuePar3: 110,
    desc: "短按",
  },
  {
    name: "侧灯亮度-",
    hex16: 0x6f,
    value16: 111,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x6f,
    valuePar3: 111,
    desc: "短按",
  },
  {
    name: "HOME->END",
    hex16: 0x70,
    value16: 112,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x70,
    valuePar3: 112,
    desc: "短按",
  },
  {
    name: "进入测试模式",
    hex16: 0x71,
    value16: 113,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x71,
    valuePar3: 113,
    desc: "长按",
  },
  {
    name: "ALT_转换",
    hex16: 0x72,
    value16: 114,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x72,
    valuePar3: 114,
    desc: "短按",
  },
  {
    name: "ENT_方向转换",
    hex16: 0x73,
    value16: 115,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x73,
    valuePar3: 115,
    desc: "短按",
  },
  {
    name: "WASD 切换为方向键",
    hex16: 0x74,
    value16: 116,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x74,
    valuePar3: 116,
    desc: "短按",
  },
  {
    name: "DELETE->HOME",
    hex16: 0x75,
    value16: 117,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x75,
    valuePar3: 117,
    desc: "短按",
  },
  {
    name: "END->INSERT",
    hex16: 0x76,
    value16: 118,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x76,
    valuePar3: 118,
    desc: "短按",
  },
  {
    name: "PAGEUP->PRINT",
    hex16: 0x77,
    value16: 119,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x77,
    valuePar3: 119,
    desc: "短按",
  },
  {
    name: "PAGEDOWN->PAUSE",
    hex16: 0x78,
    value16: 120,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x78,
    valuePar3: 120,
    desc: "短按",
  },
  {
    name: "游戏模式切换",
    hex16: 0x79,
    value16: 121,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x79,
    valuePar3: 121,
    desc: "长按",
  },
  {
    name: "灯箱亮度+",
    hex16: 0x7a,
    value16: 122,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x7a,
    valuePar3: 122,
    desc: "短按",
  },
  {
    name: "灯箱亮度-",
    hex16: 0x7b,
    value16: 123,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x7b,
    valuePar3: 123,
    desc: "短按",
  },
  {
    name: "灯箱速度+",
    hex16: 0x7c,
    value16: 124,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x7c,
    valuePar3: 124,
    desc: "短按",
  },
  {
    name: "灯箱速度-",
    hex16: 0x7d,
    value16: 125,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x7d,
    valuePar3: 125,
    desc: "短按",
  },
  {
    name: "LOGO 灯效果切换",
    hex16: 0x7e,
    value16: 126,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x7e,
    valuePar3: 126,
    desc: "短按",
  },
  {
    name: "灯箱扩散模式颜色切换",
    hex16: 0x7f,
    value16: 127,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x7f,
    valuePar3: 127,
    desc: "短按",
  },
  {
    name: "灯箱效果切换",
    hex16: 0x80,
    value16: 128,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x80,
    valuePar3: 128,
    desc: "短按",
  },
  {
    name: "灯箱颜色切换",
    hex16: 0x81,
    value16: 129,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x81,
    valuePar3: 129,
    desc: "短按",
  },
  {
    name: "拾音灯亮度加",
    hex16: 0x82,
    value16: 130,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x82,
    valuePar3: 130,
    desc: "短按",
  },
  {
    name: "拾音灯亮度减",
    hex16: 0x83,
    value16: 131,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x83,
    valuePar3: 131,
    desc: "短按",
  },
  {
    name: "拾音灯底色切换",
    hex16: 0x84,
    value16: 132,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x84,
    valuePar3: 132,
    desc: "短按",
  },
  {
    name: "拾音灯方向切换",
    hex16: 0x85,
    value16: 133,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x85,
    valuePar3: 133,
    desc: "短按",
  },
  {
    name: "WIN+。",
    hex16: 0x86,
    value16: 134,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x86,
    valuePar3: 134,
    desc: "短按",
  },
  {
    name: "CTRL+WIN+SPACEBAR",
    hex16: 0x87,
    value16: 135,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x87,
    valuePar3: 135,
    desc: "短按",
  },
  {
    name: "WIN+SHIFT+3",
    hex16: 0x88,
    value16: 136,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x88,
    valuePar3: 136,
    desc: "短按",
  },
  {
    name: "WIN+SHIFT+4",
    hex16: 0x89,
    value16: 137,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x89,
    valuePar3: 137,
    desc: "短按",
  },
  {
    name: "开启屏幕下方按键灯",
    hex16: 0x8a,
    value16: 138,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x8a,
    valuePar3: 138,
    desc: "短按",
  },
  {
    name: "红灯常亮",
    hex16: 0x8b,
    value16: 139,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x8b,
    valuePar3: 139,
    desc: "短按",
  },
  {
    name: "绿灯常亮",
    hex16: 0x8c,
    value16: 140,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x8c,
    valuePar3: 140,
    desc: "短按",
  },
  {
    name: "蓝灯常亮",
    hex16: 0x8d,
    value16: 141,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x8d,
    valuePar3: 141,
    desc: "短按",
  },
  {
    name: "自定义灯光 4",
    hex16: 0x8e,
    value16: 142,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x8e,
    valuePar3: 142,
    desc: "短按",
  },
  {
    name: "自定义灯光 5",
    hex16: 0x8f,
    value16: 143,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x8f,
    valuePar3: 143,
    desc: "短按",
  },
  {
    name: "锁全键",
    hex16: 0x90,
    value16: 144,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x90,
    valuePar3: 144,
    desc: "短按",
  },
  {
    name: "WIN+I",
    hex16: 0x91,
    value16: 145,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x91,
    valuePar3: 145,
    desc: "短按",
  },
  {
    name: "WIN+L",
    hex16: 0x92,
    value16: 146,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x92,
    valuePar3: 146,
    desc: "短按",
  },
  {
    name: "侧灯速度+",
    hex16: 0x93,
    value16: 147,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x93,
    valuePar3: 147,
    desc: "短按",
  },
  {
    name: "侧灯速度-",
    hex16: 0x94,
    value16: 148,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x94,
    valuePar3: 148,
    desc: "短按",
  },
  {
    name: "侧灯方向调节",
    hex16: 0x95,
    value16: 149,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x95,
    valuePar3: 149,
    desc: "短按",
  },
  {
    name: "切换回报率",
    hex16: 0x96,
    value16: 150,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x96,
    valuePar3: 150,
    desc: "短按",
  },
  {
    name: "PAGEUP->INSERT",
    hex16: 0x97,
    value16: 151,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x97,
    valuePar3: 151,
    desc: "短按",
  },
  {
    name: "PAGEDOWN->END",
    hex16: 0x98,
    value16: 152,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x98,
    valuePar3: 152,
    desc: "短按",
  },
  {
    name: "手动进校准",
    hex16: 0x99,
    value16: 153,
    page: "FUNC",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x00,
    valuePar2: 0,
    param3: 0x99,
    valuePar3: 153,
    desc: "短按",
  },
];

for (const item of FUNC_MAP_HFD) {
  const value = Number(item.value16 ?? item.valuePar3 ?? 0);
  registerHfdFnDisplayName(value, item.name);
}

// 日语按键
export const JA_EXTEND_MAP_HFD = [
  {
    name: "ー ¥|",
    hex16: 0x89,
    value16: 137,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x89,
    valuePar2: 137,
    desc: "日文 ¥（圆符号）键",
  },
  {
    name: "む」]}",
    hex16: 0x32,
    value16: 50,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x32,
    valuePar2: 50,
    desc: "日文右方括号键",
  },
  {
    name: "ろ\\_",
    hex16: 0x87,
    value16: 135,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x87,
    valuePar2: 135,
    desc: "日文 ろ（Ro）键",
  },
  {
    name: "無変換",
    hex16: 0x8b,
    value16: 139,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x8b,
    valuePar2: 139,
    desc: "无转换键（Non-Convert）",
  },
  {
    name: "変換",
    hex16: 0x8a,
    value16: 138,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x8a,
    valuePar2: 138,
    desc: "转换键（Convert）",
  },
  {
    name: "kana",
    hex16: 0x88,
    value16: 136,
    page: "KEYBOARD",
    param1: 0x00,
    valuePar1: 0,
    param2: 0x88,
    valuePar2: 136,
    desc: "假名模式键（Kana Mode）",
  },
];
// 汇集所有按键
export const ALL_KEYBOARD_MAP_HFD = [
  ...KEYBOARD_BASIC_MAP_HFD,
  ...KEYBOARD_EXTEND_MAP_HFD,
  ...MOUSE_MAP_HFD,
  ...CONSUMER_MAP_HFD,
  ...FUNC_MAP_HFD,
  ...JA_EXTEND_MAP_HFD,
];
// 分类按键数据
export const CLASSIFICATION_MAP_HFD: any = {
  DEFAULT: [],
  MOUSE: MOUSE_MAP_HFD,
  KEYBOARD: [...KEYBOARD_BASIC_MAP_HFD, ...KEYBOARD_EXTEND_MAP_HFD],
  CONSUMER_KEY: CONSUMER_MAP_HFD,
  SYSTEM_KEY: [...CONSUMER_MAP_HFD, ...FUNC_MAP_HFD],
  EXTRA_FUNCTION: [...MOUSE_MAP_HFD, ...CONSUMER_MAP_HFD],
  FUNC: FUNC_MAP_HFD,
};
// 按键分类
export const KEYBOARD_PAGETYPE_HFD = [
  {
    label: "DEFAULT",
    hex16: 0x00,
    value: 0,
    desc: "默认值",
  },
  {
    label: "MOUSE",
    hex16: 0x01,
    value: 1,
    desc: "鼠标按键",
  },
  {
    label: "KEYBOARD",
    hex16: 0x02,
    value: 2,
    desc: "键盘按键",
  },
  {
    label: "CONSUMER_KEY",
    hex16: 0x03,
    value: 3,
    desc: "多媒体按键",
  },
  {
    label: "SYSTEM_KEY",
    hex16: 0x04,
    value: 4,
    desc: "系统按键",
  },
  {
    label: "EXTRA_FUNCTION",
    hex16: 0x05,
    value: 5,
    desc: "特殊功能按键",
  },
  {
    label: "MACRO",
    hex16: 0x06,
    value: 6,
    desc: "快捷指令键",
  },
  {
    label: "CB",
    hex16: 0x07,
    value: 7,
    desc: "连击键（组合键）",
  },
  {
    label: "DKS",
    hex16: 0x08,
    value: 8,
    desc: "磁轴 DKS（动态键程）",
  },
  {
    label: "MT",
    hex16: 0x09,
    value: 9,
    desc: "磁轴 MT（按住/单击）",
  },
  {
    label: "TGL",
    hex16: 0x0a,
    value: 10,
    desc: "磁轴 TGL（切换开关）",
  },
  {
    label: "SOCD",
    hex16: 0x0b,
    value: 11,
    desc: "冲突消除",
  },
  {
    label: "RS",
    hex16: 0x0c,
    value: 12,
    desc: "迅洁模式",
  },
  {
    label: "FUNC",
    hex16: 0x0d,
    value: 13,
    desc: "功能按键",
  },
];

export const KEYCODE_MAP_HFD_LAYOUT = {
  huafenda87: [
    [
      41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 0, 0, 0,
      0, 0,
    ],
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 74, 75, 0, 0,
      0, 0,
    ],
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 77, 78, 0, 0,
      0, 0,
    ],
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 0, 0, 0, 0, 0, 0, 0],
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0, 0, 0, 0, 0,
      0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 101, 228, 80, 81, 79, 0,
      0, 0, 0,
    ],
  ],
  "84": [
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 70, 72, 0, 0,
      0, 0,
    ], // 16 补5个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 75, 0, 0, 0,
      0, 0,
    ], // 16 补5个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 77, 78, 0, 0, 0, 0,
      0,
    ], // 16 补5个0
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 0, 0, 0, 0, 0, 0, 0], // 13 补8个0
    [
      225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0, 0, 0, 0,
      0,
    ], // 13 补8个0
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 0, 0, 0,
      0, 0,
    ], // 10 补11个0
  ],
  "99": [
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 74, 73, 75, 78,
      0, 0,
    ], // 19 补2个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 83, 84, 85, 86, 0,
      0, 0,
    ], // 18 补3个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 95, 96, 97, 87, 0,
      0, 0,
    ], // 18 补3个0
    [
      57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 92, 93, 94, 0, 0, 0, 0,
      0,
    ], // 16 补5个0
    [
      225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 89, 90, 91,
      88, 0,
    ], // 20 补1个0
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 98, 99,
      0, 0, 0,
    ], // 10 补11个0
  ],
  "75Pro": [
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 62208, 0, 0, 0, 0,
      0, 0,
    ], //15 补6个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 0, 0, 0, 0, 0,
      0,
    ], //15 补6个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 0, 0, 0, 0, 0,
      0,
    ], //15 补6个0
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 75, 0, 0, 0, 0, 0, 0, 0], //14 补7个0
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 78, 0, 0, 0, 0, 0, 0,
      0,
    ], //14 补7个0
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 0, 0, 0,
      0, 0,
    ], //16 补5个0
  ],
  /** X75GC（华丰达）：PrtSc + Home + 右侧 Del/PgUp/PgDn */
  x75gc: [
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 74, 0, 0, 0, 0,
      0,
    ],
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 76, 0, 0, 0, 0, 0,
      0,
    ], //15 补6个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 75, 0, 0, 0, 0, 0,
      0,
    ], //15 补6个0
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 78, 0, 0, 0, 0, 0, 0, 0], //14 补7个0
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 0, 0, 0, 0, 0, 0, 0,
      0,
    ], //13 补8个0
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 230, 61697, 0, 80, 81, 79, 0, 0, 0, 0,
      0, 0,
    ], //15 无 RCtrl；RAlt/Fn 1.25U，Fn 与 ← 间 0.5U（同 BAT68）
  ],
  M98: [
    [
      41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 75, 78, 74, 8418,
      0, 0, 0,
    ], //18 补3个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 83, 84, 85, 86, 0,
      0, 0,
    ], //18 补3个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 95, 96, 97, 87, 0,
      0, 0,
    ], //18 补3个0
    [
      57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 92, 93, 94, 0, 0, 0, 0,
      0,
    ], //17 补4个0
    // Enter 紧挨 P3；与底行 0 同列，竖跨例外保证 0 可见
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 89, 90, 91, 88, 0, 0,
      0, 0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 98, 99,
      0, 0, 0,
    ],
  ],
  "75ProTFT": [
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 62208, 0, 0, 0, 0,
      0, 0,
    ], //15 补6个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 0, 0, 0, 0, 0,
      0,
    ], //15 补6个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 0, 0, 0, 0, 0,
      0,
    ], //15 补6个0
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 0, 0, 0, 0, 0, 0, 0], //14 补7个0
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 0, 0, 0, 0, 0, 0, 0,
      0,
    ], //14 补7个0
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 0, 0, 0,
      0, 0,
    ], //16 补5个0
  ],
  /** DK108：108 键全尺寸 ANSI（6×21）；已与实机 SDK getKeyData 校准通过 */
  DK108: [
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 8374,
      8397, 8373, 62208,
    ],
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 74, 75, 83,
      84, 85, 86,
    ],
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 77, 78, 95, 96,
      97, 87,
    ],
    [
      57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 0, 0, 0, 92, 93, 94,
      0,
    ],
    [
      225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0, 89, 90,
      91, 88,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 101, 228, 80, 81, 79, 98,
      99, 0, 0,
    ],
  ],
  huafenda98: [
    // Row 0: Esc + F1-F12 + 系统键 (18 keys)
    [
      41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 8594, 74, 77,
      72, 0, 0, 0,
    ],

    // Row 1: 数字行 + Backspace + 导航键 (19 cols)
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 83, 84, 85,
      86, 0, 0,
    ],

    // Row 2: Tab + 导航键 (19 cols)
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 75, 95, 96, 97, 87,
      0, 0,
    ],

    // Row 3: Caps + ASDF + Enter (17 cols)
    [
      57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 78, 92, 93, 94, 0, 0,
      0, 0,
    ],

    // Row 4: Shift + ZXCV + Shift + 方向上 (17 cols)
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 0, 89, 90, 91, 88, 0,
      0, 0, 0,
    ],

    // ✅ Row 5: 控制行 + 方向键 (11 cols)
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 228, 61697, 80, 81, 79, 98, 99, 0, 0,
      0, 0, 0, 0, 0, 0, 0, 0,
    ],
  ],
  M98TFT: [
    [
      41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 0, 0, 0, 8418, 0,
      0, 0,
    ], //18 补3个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 83, 84, 85, 86, 0,
      0, 0,
    ], //18 补3个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 95, 96, 97, 87, 0,
      0, 0,
    ], //18 补3个0
    [
      57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 92, 93, 94, 0, 0, 0, 0,
      0,
    ], //17 补4个0
    // Enter 紧挨 P3；与底行 0 同列，竖跨例外保证 0 可见
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 89, 90, 91, 88, 0, 0,
      0, 0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 98, 99,
      0, 0, 0,
    ],
  ],
  "M98 8K": [
    [
      41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 0, 0, 0, 8418, 0,
      0, 0,
    ], //18 补3个0
    [
      53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 83, 84, 85, 86, 0,
      0, 0,
    ], //18 补3个0
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 95, 96, 97, 87, 0,
      0, 0,
    ], //18 补3个0
    [
      57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 92, 93, 94, 0, 0, 0, 0,
      0,
    ], //17 补4个0
    // Enter 紧挨 P3；与底行 0 同列，竖跨例外保证 0 可见
    [
      225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 89, 90, 91, 88, 0, 0,
      0, 0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 98, 99,
      0, 0, 0,
    ],
  ],
  /**
   * 星闪 DK63 Star（非华奋达 DK63Star）：6×21，右侧 Home/Del/PgUp/PgDn，底行含 R-Ctrl。
   * 与 LAYOUT_68_KEYCODES / KEYCODE_MAP["68"] 一致。
   */
  "68": [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [
      41, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 0, 0, 0, 0, 0,
      0,
    ],
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 0, 0, 0, 0, 0,
      0,
    ],
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 75, 0, 0, 0, 0, 0, 0],
    [
      225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 78, 0, 0, 0, 0, 0,
      0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 230, 61697, 228, 80, 81, 79, 0, 0, 0, 0,
      0, 0,
    ],
  ],
  /**
   * 华奋达 DK63Star（0C45:80F8）：对齐星闪 DK63 V2 虚拟键盘矩阵（6×14，单灯）。
   * 底行右簇为 V2 序：RAlt、Fn、←、↓、→；
   * Shift 行 col11–13 为 R-Shift、↑、/?（相对 V2 公版矩阵互换了 R-Shift 与 /?）。
   */
  "63": [
    [0],
    [41, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42],
    [43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49],
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40],
    [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 229, 82, 56],
    [224, 227, 226, 0, 0, 0, 44, 0, 0, 230, 61697, 80, 81, 79],
  ],
  /** BAT68：基于 DEEP68/`68`，最右侧自上而下为 Home / End / PgUp / PgDn */
  huafenda68: [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [
      41, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 0, 0, 0, 0, 0,
      0,
    ],
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 77, 0, 0, 0, 0, 0,
      0,
    ],
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 75, 0, 0, 0, 0, 0, 0],
    [
      225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 78, 0, 0, 0, 0, 0,
      0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 230, 61697, 0, 80, 81, 79, 0, 0, 0, 0,
      0, 0,
    ],
  ],
  /** Tank68 HE：华奋达 68 磁轴，右侧导航列同 BAT68，底行含 R-Ctrl */
  tank68he: [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [
      41, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 0, 0, 0, 0, 0,
      0,
    ],
    [
      43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 77, 0, 0, 0, 0, 0,
      0,
    ],
    [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 75, 0, 0, 0, 0, 0, 0],
    [
      225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 78, 0, 0, 0, 0, 0,
      0,
    ],
    [
      224, 227, 226, 0, 0, 0, 44, 0, 0, 230, 61697, 228, 80, 81, 79, 0, 0, 0, 0,
      0, 0,
    ],
  ],
};
const NEW_KEYCODE_MAP_HFD = new Map(
  KEYCODE_MAP_HFD.map((item: any) => {
    return [item.keycode, item];
  })
);
// 将 keyCode 映射到 HFD 协议 keyIndex
const NEW_KEYCODE_TO_INDEX_HFD = new Map(
  KEYCODE_MAP_HFD.filter(
    (item: any) =>
      typeof item?.keycode === "number" && typeof item?.keyIndex === "number"
  ).map((item: any) => [Number(item.keycode), Number(item.keyIndex)])
);

// HFD 固件 keyData 槽位数（@hfd-sdk/keyboard-sdk：128 槽 × 4 字节 = 512 字节）
export const HFD_KEY_SLOT_COUNT = 128;
export const HFD_KEYDATA_BYTE_LENGTH = HFD_KEY_SLOT_COUNT * 4;

/** 按 keyIndex 最大值推导的物理键数量（≤ HFD_KEY_SLOT_COUNT） */
const HFD_PHYSICAL_SLOT_COUNT =
  KEYCODE_MAP_HFD.reduce((max: number, item: any) => {
    const idx = Number(item?.keyIndex);
    return Number.isFinite(idx) ? Math.max(max, idx) : max;
  }, 0) + 1;

export type HfdKeyDataReadyResult = {
  keyData: any[];
  usedShadow: boolean;
  wasAllZero: boolean;
  /** 2.4G 等场景下 getKeyData 可能截断；禁止零填充后整表 setKeyData */
  incomplete?: boolean;
};

const EMPTY_HFD_SLOT = {
  pageType: 0,
  param1: 0,
  param2: 0,
  param3: 0,
};

export const normalizeHfdFlatKeyData = (keyData: any[]): any[] => {
  const list = Array.isArray(keyData) ? keyData : [];
  return Array.from({ length: HFD_KEY_SLOT_COUNT }, (_, i) => {
    const item = list[i];
    if (!item || typeof item !== "object") {
      return { ...EMPTY_HFD_SLOT };
    }
    return {
      pageType: Number(item.pageType ?? 0),
      param1: Number(item.param1 ?? 0),
      param2: Number(item.param2 ?? 0),
      param3: Number(item.param3 ?? 0),
    };
  });
};

/** 将单槽 flat 数据转为 SDK setKeyData 所需的 userKey（与 @hfd-sdk 编码一致） */
export const hfdSlotToSetKeyUserKey = (
  slot: any,
  slotIndex: number
): Record<string, unknown> | null => {
  const pageType = Number(slot?.pageType ?? 0);
  const param1 = Number(slot?.param1 ?? 0);
  const param2 = Number(slot?.param2 ?? 0);
  const param3 = Number(slot?.param3 ?? 0);

  if (pageType === 0 && param1 === 0 && param2 === 0 && param3 === 0) {
    const meta = KEYCODE_MAP_HFD.find(
      (item: any) =>
        Number(item.keyIndex) === slotIndex &&
        item.hex16 != null &&
        item.hex16 !== ""
    );
    if (!meta) return null;
    const hex =
      typeof meta.hex16 === "string"
        ? parseInt(meta.hex16, 16)
        : Number(meta.hex16);
    if (!Number.isFinite(hex) || hex <= 0) return null;
    return { name: meta.name, value: hex, page: "KEYBOARD" };
  }

  switch (pageType) {
    case 1:
      return { name: "MOUSE", page: "MOUSE", param1, value: param2 };
    case 2: {
      const meta = KEYCODE_MAP_HFD.find(
        (item: any) => Number(item.keyIndex) === slotIndex
      );
      if (!Number.isFinite(param2) || param2 <= 0) return null;
      return {
        name: meta?.name ?? "",
        value: param2,
        page: "KEYBOARD",
      };
    }
    case 3: {
      const value = param1 | (param2 << 8);
      return { name: "", page: "CONSUMER_KEY", value };
    }
    case 6:
      return {
        name: `M${param1}`,
        page: "MACRO",
        param1,
        param2,
        param3,
      };
    case 7:
      return { name: "CB", page: "CB", param1, param2, param3 };
    case 8:
      // SDK V()：DKS 仅写 value（索引），不是 param1/2/3
      return { name: "DKS", page: "DKS", value: param1 };
    case 9:
      return { name: "MT", page: "MT", param1, param2, param3 };
    case 10:
      return { name: "TGL", page: "TGL", value: param1 };
    case 11:
      return { name: "SOCD", page: "SOCD", param1, param2, param3 };
    case 12:
      return { name: "RS", page: "RS", param1, param2, param3 };
    case 13: {
      const value = (param1 << 16) | (param2 << 8) | param3;
      return { name: "FUNC", page: "FUNC", value };
    }
    case 14:
      return { name: "END", page: "END", param1, param2 };
    default:
      return null;
  }
};

export const HFD_KEYDATA_INCOMPLETE_MSG = "HFD键位数据读取不完整，请稍后重试";

/** 2.4G 脏包：长度完整但内容错乱，禁止整表写回固件 */
export const HFD_KEYDATA_UNTRUSTED_MSG =
  "HFD键位数据不可信，请稍后重试（2.4G 干扰时请勿改键）";

const NEW_KEYBOARD_PAGETYPE_HFD = new Map(
  KEYBOARD_PAGETYPE_HFD.map((item: any) => {
    return [item.value, item];
  })
);

// 兼容 SDK 可能返回 Uint8Array / ArrayBuffer / number[] 三种字节流
const isNumericArray = (data: any) =>
  Array.isArray(data) && data.every((v) => typeof v === "number");

const toUint8Array = (data: any): Uint8Array | null => {
  if (data instanceof Uint8Array) {
    return data;
  }
  if (data instanceof ArrayBuffer) {
    return new Uint8Array(data);
  }
  if (isNumericArray(data)) {
    return Uint8Array.from(data);
  }
  return null;
};

// 将 4 字节槽位缓冲区解码为 pageType/param 结构（与 @hfd-sdk getKeyData 一致）
const decodeHfdBufferToKeyData = (buffer: Uint8Array) => {
  const result: Array<{
    pageType: number;
    param1: number;
    param2: number;
    param3: number;
  }> = new Array(HFD_KEY_SLOT_COUNT);

  for (let i = 0; i < HFD_KEY_SLOT_COUNT; i++) {
    const offset = i * 4;
    result[i] = {
      pageType: buffer[offset] ?? 0,
      param1: buffer[offset + 1] ?? 0,
      param2: buffer[offset + 2] ?? 0,
      param3: buffer[offset + 3] ?? 0,
    };
  }

  return result;
};

// 判断 keyData 是否处于“DEFAULT 全零”状态
export const isHfdKeyDataAllZero = (keyData: any): boolean => {
  const buffer = toUint8Array(keyData);
  if (buffer) {
    return buffer.every((v) => v === 0);
  }

  if (Array.isArray(keyData)) {
    if (keyData.length === 0) return true;
    return keyData.every((item: any) => {
      if (!item || typeof item !== "object") return true;
      const pageType = Number(item.pageType ?? 0);
      const param1 = Number(item.param1 ?? 0);
      const param2 = Number(item.param2 ?? 0);
      const param3 = Number(item.param3 ?? 0);
      return pageType === 0 && param1 === 0 && param2 === 0 && param3 === 0;
    });
  }

  return true;
};

const isHfdKeyDataBufferIncomplete = (buffer: Uint8Array): boolean => {
  if (buffer.length === 0) return true;
  if (buffer.length >= HFD_KEYDATA_BYTE_LENGTH) return false;
  return !isHfdKeyDataAllZero(buffer);
};

const isHfdKeyDataArrayIncomplete = (keyData: any[]): boolean => {
  if (!Array.isArray(keyData) || keyData.length === 0) return true;
  if (keyData.length >= HFD_KEY_SLOT_COUNT) return false;
  return !isHfdKeyDataAllZero(keyData);
};

const isHfdSlotNonEmpty = (slot: any): boolean => {
  if (!slot || typeof slot !== "object") return false;
  return !(
    Number(slot.pageType ?? 0) === 0 &&
    Number(slot.param1 ?? 0) === 0 &&
    Number(slot.param2 ?? 0) === 0 &&
    Number(slot.param3 ?? 0) === 0
  );
};

/** 当前型号布局矩阵中、可映射到 keyIndex 的物理键数量 */
export const countHfdExpectedPhysicalSlots = (keyboardType: string): number => {
  const layout =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!layout?.length) return 0;
  const seen = new Set<number>();
  for (const row of layout) {
    if (!Array.isArray(row)) continue;
    for (const code of row) {
      const keycode = Number(code ?? 0);
      if (keycode <= 0) continue;
      const idx = NEW_KEYCODE_TO_INDEX_HFD.get(keycode);
      if (idx == null || !Number.isFinite(idx) || idx < 0) continue;
      seen.add(idx);
    }
  }
  return seen.size;
};

/**
 * 统计布局矩阵对应物理槽中，keyData 非空槽数量。
 * 半包零填充后常见「前段有值、后段全 0」，覆盖率会明显偏低。
 */
export const countHfdPopulatedPhysicalSlots = (
  keyData: any[],
  keyboardType: string
): number => {
  const layout =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!layout?.length || !Array.isArray(keyData)) return 0;
  const seen = new Set<number>();
  let populated = 0;
  for (const row of layout) {
    if (!Array.isArray(row)) continue;
    for (const code of row) {
      const keycode = Number(code ?? 0);
      if (keycode <= 0) continue;
      const idx = NEW_KEYCODE_TO_INDEX_HFD.get(keycode);
      if (idx == null || !Number.isFinite(idx) || seen.has(idx)) continue;
      seen.add(idx);
      if (isHfdSlotNonEmpty(keyData[idx])) populated += 1;
    }
  }
  return populated;
};

/** 长度看似完整但物理槽覆盖过低 → 视为半包/脏包（禁止写回、展示兜底） */
export const isHfdKeyDataPhysicallySparse = (
  keyData: any[],
  keyboardType: string,
  minCoverage = 0.55
): boolean => {
  const expected = countHfdExpectedPhysicalSlots(keyboardType);
  if (expected < 8) return false;
  const populated = countHfdPopulatedPhysicalSlots(keyData, keyboardType);
  return populated / expected < minCoverage;
};

// 影子填充：按当前型号默认物理布局，把默认键码写回空缓冲区（128 槽 × 4 字节）
// 协议约定：pageType=2(KEYBOARD)，param2=HID 键值
export const populateHfdDefaultBuffer = (
  keyboardType: string,
  buffer: Uint8Array
) => {
  const layout =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!layout || !Array.isArray(layout)) {
    return buffer;
  }

  layout.forEach((row: any[]) => {
    row.forEach((physicalKeyCode: number) => {
      if (!physicalKeyCode) return;
      const physicalId = NEW_KEYCODE_TO_INDEX_HFD.get(Number(physicalKeyCode));
      if (physicalId === undefined) return;
      const meta = KEYCODE_MAP_HFD.find(
        (item: any) => Number(item.keycode) === Number(physicalKeyCode)
      );
      const hexRaw = meta?.hex16;
      const code =
        hexRaw != null && hexRaw !== ""
          ? typeof hexRaw === "string"
            ? parseInt(hexRaw, 16)
            : Number(hexRaw)
          : Number(physicalKeyCode) & 0xff;
      if (!Number.isFinite(code) || code <= 0) return;
      const offset = physicalId * 4;
      if (offset + 3 >= buffer.length) return;
      buffer[offset] = 2;
      buffer[offset + 1] = 0;
      buffer[offset + 2] = code & 0xff;
      buffer[offset + 3] = (code >> 8) & 0xff;
    });
  });

  return buffer;
};

// 构建默认键位数据：
// 用 4 字节协议格式 {pageType, param1, param2, param3}，从布局矩阵读取物理键码，
// 通过 ALL_KEYBOARD_MAP_HFD 查找正确的协议参数值（如 Fn 键的 valuePar2=175 而非 keycode=61697）
const buildDefaultHfdKeyData = (keyboardType: string) => {
  const layout =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!layout || !Array.isArray(layout)) return [];

  const pageTypeByLabel: Record<string, number> = {};
  KEYBOARD_PAGETYPE_HFD.forEach((item: any) => {
    pageTypeByLabel[item.label] = item.value;
  });

  const slotCount = 128;
  const result: Array<{
    pageType: number;
    param1: number;
    param2: number;
    param3: number;
  }> = new Array(slotCount);
  for (let i = 0; i < slotCount; i++) {
    result[i] = { pageType: 0, param1: 0, param2: 0, param3: 0 };
  }

  layout.forEach((row: any[]) => {
    row.forEach((physicalKeyCode: number) => {
      if (!physicalKeyCode) return;

      const physicalId = NEW_KEYCODE_TO_INDEX_HFD.get(Number(physicalKeyCode));
      if (physicalId === undefined || physicalId >= slotCount) return;

      // 优先按 value16 匹配，兜底按 xsKeycode
      let keyDef = ALL_KEYBOARD_MAP_HFD.find(
        (item: any) => item.value16 === physicalKeyCode
      );
      if (!keyDef) {
        keyDef = ALL_KEYBOARD_MAP_HFD.find(
          (item: any) => item.xsKeycode === physicalKeyCode
        );
      }
      if (!keyDef) return;

      const pageType = pageTypeByLabel[keyDef.page] ?? 0;
      result[physicalId] = {
        pageType,
        param1: keyDef.valuePar1 ?? 0,
        param2: keyDef.valuePar2 ?? 0,
        param3: 0,
      };
    });
  });

  return result;
};

const markSparseIfNeeded = (
  result: HfdKeyDataReadyResult,
  keyboardType: string
): HfdKeyDataReadyResult => {
  if (result.incomplete || result.usedShadow || result.wasAllZero) {
    return result;
  }
  if (isHfdKeyDataPhysicallySparse(result.keyData, keyboardType)) {
    return { ...result, incomplete: true };
  }
  return result;
};

// 统一就绪入口：
// 1) 检测全零
// 2) 必要时执行影子填充
// 3) 输出后续解析可直接使用的 keyData 结构
// 4) 半包零填充 / 物理槽稀疏 → incomplete
export const ensureHfdKeyDataReady = (
  rawKeyData: any,
  keyboardType: string
): HfdKeyDataReadyResult => {
  const wasAllZero = isHfdKeyDataAllZero(rawKeyData);

  const shadowDefaults = (): HfdKeyDataReadyResult => ({
    keyData: normalizeHfdFlatKeyData(buildDefaultHfdKeyData(keyboardType)),
    usedShadow: true,
    wasAllZero: true,
  });

  const bufferFromRaw = toUint8Array(rawKeyData);
  if (bufferFromRaw) {
    if (wasAllZero) {
      return shadowDefaults();
    }

    const lengthIncomplete = isHfdKeyDataBufferIncomplete(bufferFromRaw);
    const workingBuffer = new Uint8Array(
      Math.max(bufferFromRaw.length, HFD_KEYDATA_BYTE_LENGTH)
    );
    workingBuffer.set(bufferFromRaw.slice(0, workingBuffer.length));
    const keyData = normalizeHfdFlatKeyData(
      decodeHfdBufferToKeyData(workingBuffer)
    );
    return markSparseIfNeeded(
      {
        keyData,
        usedShadow: false,
        wasAllZero,
        incomplete: lengthIncomplete,
      },
      keyboardType
    );
  }

  if (Array.isArray(rawKeyData)) {
    if (wasAllZero) {
      return shadowDefaults();
    }
    const keyData = normalizeHfdFlatKeyData(rawKeyData);
    return markSparseIfNeeded(
      {
        keyData,
        usedShadow: false,
        wasAllZero,
        incomplete: isHfdKeyDataArrayIncomplete(rawKeyData),
      },
      keyboardType
    );
  }

  if (wasAllZero) {
    return shadowDefaults();
  }

  return {
    keyData: normalizeHfdFlatKeyData([]),
    usedShadow: false,
    wasAllZero,
    incomplete: true,
  };
};

/** 带重试的 keyData 读取（2.4G 截断时重试，禁止零填充后整表写入） */
export const readHfdKeyDataReady = async (
  getKeyData: () => Promise<any>,
  keyboardType: string,
  options?: { maxAttempts?: number; retryDelayMs?: number }
): Promise<HfdKeyDataReadyResult> => {
  const maxAttempts = Math.max(1, options?.maxAttempts ?? 5);
  const retryDelayMs = options?.retryDelayMs ?? 150;
  let last: HfdKeyDataReadyResult = {
    keyData: normalizeHfdFlatKeyData([]),
    usedShadow: false,
    wasAllZero: true,
    incomplete: true,
  };

  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const raw = await getKeyData();
    last = ensureHfdKeyDataReady(raw, keyboardType);
    if (!last.incomplete) {
      return last;
    }
    if (attempt < maxAttempts - 1) {
      await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
    }
  }
  return last;
};

/** 首进子应用需校验默认布局的华奋达型号（keyData 半包时易出现 F 行重复等错乱） */
const HFD_LAYOUT_VALIDATE_KEYBOARD_TYPES = new Set([
  "huafenda87",
  "84",
  "75Pro",
  "x75gc",
  "75ProTFT",
  "M98",
  "M98TFT",
  "DK108",
  "M98 8K",
]);

/**
 * 由 getKeyLayout 行数据构建 web code → setMusicData / setCustomLED 用的 keyIndex。
 * 须与灯光页 KEYCODE_MAP_HFD.keyIndex 一致；ledBeads 为物理灯珠序，不可直接用于律动下发。
 */
export function buildHfdWebCodeToLedIndexMap(
  rows: Array<{ keyboardLayout?: number[]; ledBeads?: number[] }>
): Record<string, number> {
  const map: Record<string, number> = {};
  for (const row of rows) {
    const keycodes = row.keyboardLayout ?? [];
    const leds = row.ledBeads ?? [];
    for (let col = 0; col < keycodes.length; col++) {
      const keycode = Number(keycodes[col] ?? 0);
      if (keycode <= 0) continue;
      const fromKeycode = NEW_KEYCODE_TO_INDEX_HFD.get(keycode);
      const ledIndex =
        fromKeycode != null && fromKeycode >= 0
          ? fromKeycode
          : Number(leds[col] ?? -1);
      if (!Number.isFinite(ledIndex) || ledIndex < 0) continue;
      const webKey = KEYCODE_TO_WEB_KEY_MAP[keycode];
      if (webKey) {
        map[webKey] = ledIndex;
      }
    }
  }
  return map;
}

export function shouldValidateHfdLayoutAgainstDefault(
  keyboardType: string
): boolean {
  const type = String(keyboardType || "");
  if (HFD_LAYOUT_VALIDATE_KEYBOARD_TYPES.has(type)) return true;
  // 其余已登记布局的型号同样做错乱检测（仅对 corruption 重试，不影响已改键）
  const layout =
    KEYCODE_MAP_HFD_LAYOUT[type as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  return Array.isArray(layout) && layout.length > 0;
}

const rowNonZeroKeycodes = (row: number[] | undefined): number[] => {
  if (!Array.isArray(row)) return [];
  return row.map((c) => Number(c ?? 0)).filter((c) => c > 0);
};

/** 与 KEYCODE_MAP_HFD_LAYOUT 出厂矩阵比对（非零格一致视为匹配） */
export function isHfdLayoutMatchingDefault(
  rows: Array<{ keyboardLayout?: number[] }>,
  keyboardType: string,
  totalRows?: number
): boolean {
  if (!shouldValidateHfdLayoutAgainstDefault(keyboardType)) return true;
  const expected =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!expected || !Array.isArray(expected)) return true;

  const rowCount = Math.min(
    totalRows ?? expected.length,
    expected.length,
    rows.length
  );
  for (let i = 0; i < rowCount; i++) {
    const expectedRow = expected[i];
    const fetchedRow = rows[i]?.keyboardLayout;
    if (!Array.isArray(expectedRow) || !Array.isArray(fetchedRow)) {
      return false;
    }
    for (let col = 0; col < expectedRow.length; col++) {
      const exp = Number(expectedRow[col] ?? 0);
      const got = Number(fetchedRow[col] ?? 0);
      if (exp === 0) continue;
      if (exp !== got) return false;
    }
  }
  return true;
}

/** 由 KEYCODE_MAP_HFD_LAYOUT 构建静态 SDK 行布局（虚拟键盘兜底） */
export function buildHfdStaticLayoutRows(
  keyboardType: string,
  layer = 0
): Array<{ layer: number; row: number; keyboardLayout: number[] }> {
  const matrix =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!matrix?.length) return [];
  return matrix.map((row, rowIndex) => ({
    layer,
    row: rowIndex,
    keyboardLayout: row.map((cell) => Number(cell ?? 0)),
  }));
}

const hfdRowHeadSignature = (row: number[] | undefined, take = 6): string =>
  rowNonZeroKeycodes(row).slice(0, take).join(",");

/** HID F1–F12 */
const HFD_F_KEY_CODES = new Set([
  58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69,
]);

/** HID 小键盘区（TKL 如 X87 不应成片出现） */
const HFD_NUMPAD_KEY_CODES = new Set([
  83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

const countFKeyCodes = (codes: number[]): number =>
  codes.filter((c) => HFD_F_KEY_CODES.has(c)).length;

const countNumpadKeyCodes = (codes: number[]): number =>
  codes.filter((c) => HFD_NUMPAD_KEY_CODES.has(c)).length;

/** 典型错乱：行首重复、行错位（keyData 半包时 F 区/数字行串行） */
export function isHfdLayoutCorrupted(
  rows: Array<{ keyboardLayout?: number[] }>,
  keyboardType: string
): boolean {
  if (!shouldValidateHfdLayoutAgainstDefault(keyboardType)) return false;
  if (!rows?.length || rows.length < 2) return false;

  const expected =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!expected?.[0] || !expected?.[1]) return false;

  const row0 = rows[0]?.keyboardLayout ?? [];
  const row1 = rows[1]?.keyboardLayout ?? [];
  const nz0 = rowNonZeroKeycodes(row0);
  const nz1 = rowNonZeroKeycodes(row1);

  if (nz0.length > 4 && nz1.length > 4) {
    const head0 = nz0.slice(0, 6).join(",");
    const head1 = nz1.slice(0, 6).join(",");
    if (head0 === head1) return true;
  }

  const exp0Head = rowNonZeroKeycodes(expected[0]).slice(0, 6).join(",");
  const exp1Head = rowNonZeroKeycodes(expected[1]).slice(0, 6).join(",");
  const row0Head = nz0.slice(0, 6).join(",");
  // 出厂第 0 行为空占位（如 huafenda68）时，勿把「行首像第 1 行」判成串行错乱
  if (exp0Head && row0Head === exp1Head && row0Head !== exp0Head) return true;

  const rowCount = Math.min(rows.length, expected.length);
  for (let i = 0; i < rowCount; i++) {
    const actualHead = hfdRowHeadSignature(rows[i]?.keyboardLayout, 4);
    if (!actualHead) continue;
    const expectedHead = hfdRowHeadSignature(expected[i], 4);
    if (actualHead === expectedHead) continue;
    // 期望行为空占位时跳过交叉比对，避免 68 空 F 行误杀
    if (!expectedHead) continue;
    for (let j = 0; j < expected.length; j++) {
      if (i === j) continue;
      const otherExpectedHead = hfdRowHeadSignature(expected[j], 4);
      if (!otherExpectedHead) continue;
      if (actualHead === otherExpectedHead) return true;
    }
  }

  // 数字行出现大量 F 键：2.4G 脏包/半包最典型症状（截图：第二行 F2–F12）
  if (countFKeyCodes(nz1) >= 4) return true;

  return false;
}

/** 与出厂矩阵比对，统计非零格不一致数量 */
export function countHfdLayoutMismatches(
  rows: Array<{ keyboardLayout?: number[] }>,
  keyboardType: string
): { mismatch: number; expected: number } {
  const matrix =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!matrix?.length) return { mismatch: 0, expected: 0 };

  let expected = 0;
  let mismatch = 0;
  const rowCount = Math.min(rows.length, matrix.length);
  for (let r = 0; r < rowCount; r++) {
    const expRow = matrix[r] ?? [];
    const gotRow = rows[r]?.keyboardLayout ?? [];
    const colCount = Math.max(expRow.length, gotRow.length);
    for (let c = 0; c < colCount; c++) {
      const exp = Number(expRow[c] ?? 0);
      if (exp <= 0) continue;
      expected += 1;
      const got = Number(gotRow[c] ?? 0);
      if (got !== exp) mismatch += 1;
    }
  }
  return { mismatch, expected };
}

/**
 * 解码结果是否不可信（2.4G 脏包）：高错配率 / F 键串行 / TKL 上成片小键盘键。
 * 少量改键（错配率低）视为可信。
 */
export function isHfdDecodedLayoutUntrusted(
  rows: Array<{ keyboardLayout?: number[] }>,
  keyboardType: string
): boolean {
  if (!rows?.length) return true;
  if (isHfdLayoutCorrupted(rows, keyboardType)) return true;

  const matrix =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!matrix?.length) return false;

  // F 键大量出现在非功能行
  for (let r = 1; r < rows.length; r++) {
    const nz = rowNonZeroKeycodes(rows[r]?.keyboardLayout);
    if (countFKeyCodes(nz) >= 3) return true;
  }

  // 出厂无小键盘的配列，却出现成片 numpad 码（如 X87 上的 P1/P2…）
  const factoryHasNumpad = matrix.some((row) =>
    row.some((code) => HFD_NUMPAD_KEY_CODES.has(Number(code ?? 0)))
  );
  if (!factoryHasNumpad) {
    let numpadHits = 0;
    for (const row of rows) {
      numpadHits += countNumpadKeyCodes(
        rowNonZeroKeycodes(row?.keyboardLayout)
      );
    }
    if (numpadHits >= 3) return true;
  }

  const { mismatch, expected } = countHfdLayoutMismatches(rows, keyboardType);
  if (expected >= 20 && mismatch / expected > 0.28) return true;

  return false;
}

/** keyData 不可信或布局错乱时，是否应回退到出厂静态矩阵展示 */
export function shouldUseHfdStaticLayoutFallback(
  rows: Array<{ keyboardLayout?: number[] }>,
  keyboardType: string,
  options?: {
    keyDataIncomplete?: boolean;
    usedShadow?: boolean;
    wasAllZero?: boolean;
    /** 仅根据读包完整性判断（勿传空 rows 触发「无行即兜底」） */
    integrityOnly?: boolean;
  }
): boolean {
  const layout =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!layout?.length) return false;

  // 半包 / 影子 / 全零：首屏可用静态兜底（改键回显场景由 allowStaticFallback 关闭）
  if (
    options?.keyDataIncomplete ||
    options?.usedShadow ||
    options?.wasAllZero
  ) {
    return true;
  }

  if (options?.integrityOnly) return false;

  if (!shouldValidateHfdLayoutAgainstDefault(keyboardType)) return false;
  if (!rows?.length) return true;
  // 脏包错乱（含 F 键串行 / TKL 小键盘）一律静态兜底
  if (isHfdDecodedLayoutUntrusted(rows, keyboardType)) return true;
  return false;
}

export type HfdFnKeySlot = {
  pageType: number;
  param1: number;
  param2: number;
  param3: number;
};

export function isHfdFnKeySlotEmpty(
  slot: HfdFnKeySlot | null | undefined
): boolean {
  if (!slot) return true;
  return (
    Number(slot.pageType ?? 0) === 0 &&
    Number(slot.param1 ?? 0) === 0 &&
    Number(slot.param2 ?? 0) === 0 &&
    Number(slot.param3 ?? 0) === 0
  );
}

function pickHfdFnDisplayValue(meta: any): number {
  if (!meta) return 0;
  const priorityPages = ["MOUSE", "FUNC", "CONSUMER_KEY", "FUNC_V2"];
  if (priorityPages.includes(meta.page) || meta.name === "Fn") {
    return Number(meta.value16 ?? meta.valuePar2 ?? meta.xsKeycode ?? 0);
  }
  return Number(meta.xsKeycode ?? meta.value16 ?? meta.valuePar2 ?? 0);
}

/** 将 Fn 层槽位解析为虚拟键盘展示用 keyCode */
export async function resolveHfdFnSlotDisplayKeyCode(
  slot: HfdFnKeySlot | null | undefined,
  layoutKeyCode = 0
): Promise<number> {
  if (isHfdFnKeySlotEmpty(slot)) return 0;

  const pageType = Number(slot!.pageType ?? 0);

  if (pageType === 6) {
    let xsKeycode = 0;
    Object.entries(KEYCODE_MACRO_MAP).find(([key, value]) => {
      if (value.index === Number(slot!.param1)) {
        xsKeycode = Number(key);
      }
    });
    return xsKeycode || 0;
  }

  if ([7, 8, 9, 10, 11, 12, 14, 15].includes(pageType)) {
    return layoutKeyCode || 0;
  }

  if (pageType >= 128) {
    const funcValue = decodeHfdFnV2FuncValue(slot!);
    if (funcValue) {
      return resolveHfdFnFuncDisplayKeyCode(funcValue, { v2: true });
    }
    return 0;
  }

  if (pageType === 13) {
    const funcValue = decodeHfdFnV1FuncValue(slot!);
    if (funcValue) {
      const hit = ALL_KEYBOARD_MAP_HFD.find(
        (item: any) =>
          Number(item.value16) === funcValue ||
          Number(item.xsKeycode) === funcValue
      );
      if (hit) {
        const code = pickHfdFnDisplayValue(hit);
        if (code) return code;
      }
      return resolveHfdFnFuncDisplayKeyCode(funcValue, { v2: false });
    }
  }

  const data = await getKeyDataByPageName(pageType);
  const match = data?.find((items: any) => getKeyInfoByParams(slot, items));
  if (match) {
    const code = pickHfdFnDisplayValue(match);
    if (code) {
      const hit = ALL_KEYBOARD_MAP_HFD.find(
        (item: any) =>
          Number(item.xsKeycode) === code ||
          Number(item.value16) === code ||
          Number(item.keycode) === code
      );
      if (hit?.xsKeycode) return Number(hit.xsKeycode);
      if (hit?.name) {
        const funcValue = Number(hit.value16 ?? hit.valuePar3 ?? 0);
        if (funcValue) {
          return resolveHfdFnFuncDisplayKeyCode(funcValue, { v2: false });
        }
      }
      return code;
    }
    if (match.name && (match.page === "FUNC" || match.page === "FUNC_V2")) {
      const funcValue = Number(match.value16 ?? match.value ?? 0);
      if (funcValue) {
        return resolveHfdFnFuncDisplayKeyCode(funcValue, {
          v2: match.page === "FUNC_V2",
        });
      }
    }
  }

  return 0;
}

/** 按布局行 + Fn keyData 生成虚拟键盘一行 keyCode（layer 1） */
export async function resolveHfdRowFnKeyCodes(
  rowLayout: number[],
  fnKeyData: HfdFnKeySlot[],
  defaultFnKeys?: HfdFnKeySlot[]
): Promise<number[]> {
  const result: number[] = [];
  for (let i = 0; i < rowLayout.length; i++) {
    const layoutCode = Number(rowLayout[i] ?? 0);
    if (!layoutCode) {
      result.push(0);
      continue;
    }
    const keyIndex = NEW_KEYCODE_MAP_HFD.get(layoutCode)?.keyIndex;
    if (keyIndex == null || !Number.isFinite(keyIndex)) {
      result.push(0);
      continue;
    }
    const fnSlot = fnKeyData?.[keyIndex];
    const defaultSlot = defaultFnKeys?.[keyIndex];
    const effectiveSlot = isHfdFnKeySlotEmpty(fnSlot) ? defaultSlot : fnSlot;
    const code = await resolveHfdFnSlotDisplayKeyCode(
      effectiveSlot,
      layoutCode
    );
    if (code) {
      result.push(code);
    } else if (isHfdFnKeySlotEmpty(effectiveSlot)) {
      result.push(layoutCode || 0);
    } else {
      result.push(0);
    }
  }
  return result;
}

// 通过pageType获取分类名称
export const getPageTypeLabel = async (pageType: number) => {
  return NEW_KEYBOARD_PAGETYPE_HFD.get(pageType)?.label;
  // return KEYBOARD_PAGETYPE_HFD.find((item) => item.value === pageType)?.label;
};
// 通过分类名称获取按键数据
export const getKeyDataByPageName = async (pageType: any) => {
  const pageTypeLabel: any = await getPageTypeLabel(pageType);
  return CLASSIFICATION_MAP_HFD[pageTypeLabel];
};
// 通过华奋达126个按键数据和标准按键编码，获取对应按键数据
export const getHfdKeyInfoByKeyCode = async (
  keyCodeData: any,
  keyCode: number
) => {
  // const keyIndex: any = KEYCODE_MAP_HFD.find((item: any) => {
  //   return item.keycode === keyCode;
  // })?.keyIndex;
  const keyIndex: any = NEW_KEYCODE_MAP_HFD.get(keyCode)?.keyIndex;
  const keyCodeItem =
    keyIndex !== undefined && Array.isArray(keyCodeData)
      ? keyCodeData[keyIndex]
      : null;

  // 媒体/灯光/FUNC 类键（如 62208）可能没有 keyIndex，先走兜底直查，避免空指针
  if (!keyCodeItem) {
    return (
      ALL_KEYBOARD_MAP_HFD.find(
        (item: any) =>
          item?.xsKeycode === keyCode ||
          item?.value16 === keyCode ||
          item?.keycode === keyCode
      ) || null
    );
  }

  if (keyCodeItem.pageType === 6) {
    let xsKeycode = "";
    Object.entries(KEYCODE_MACRO_MAP).find(([key, value]) => {
      if (value.index === keyCodeItem.param1) {
        xsKeycode = key;
      }
    });
    return { xsKeycode };
  }

  // 高级键槽位仍显示物理键名（SOCD/MT/TGL 等），避免虚拟键盘整盘错位
  const advPageType = Number(keyCodeItem.pageType ?? 0);
  if ([7, 8, 9, 10, 11, 12, 14, 15].includes(advPageType)) {
    return (
      ALL_KEYBOARD_MAP_HFD.find(
        (item: any) =>
          Number(item.keycode) === Number(keyCode) ||
          Number(item.xsKeycode) === Number(keyCode) ||
          Number(item.value16) === Number(keyCode)
      ) || null
    );
  } else {
    const data = await getKeyDataByPageName(keyCodeItem.pageType);
    const p = data?.find((items: any) => {
      return getKeyInfoByParams(keyCodeItem, items);
    });
    if (p) return p;

    // 当 pageType/param 匹配失败（如 DEFAULT）时，按目标键码直接匹配
    return (
      ALL_KEYBOARD_MAP_HFD.find(
        (item: any) =>
          item?.xsKeycode === keyCode ||
          item?.value16 === keyCode ||
          item?.keycode === keyCode
      ) || null
    );
  }
};

/**
 * 按 LayoutMatrix + keyIndex 解码展示行（几何只信静态矩阵，功能只信 keyData[slot]）。
 * 不依赖 SDK getKeyLayout 逐行往返，避免与并发 HID 交错。
 */
export async function buildHfdSdkRowsFromKeyData(
  keyboardType: string,
  keyData: any[],
  layer = 0,
  totalRows?: number
): Promise<
  Array<{
    layer: number;
    row: number;
    keyboardLayout: number[];
    keyboardData: any[];
  }>
> {
  const matrix =
    KEYCODE_MAP_HFD_LAYOUT[keyboardType as keyof typeof KEYCODE_MAP_HFD_LAYOUT];
  if (!matrix?.length) return [];

  const rowLimit = Math.min(totalRows ?? matrix.length, matrix.length);
  const rows: Array<{
    layer: number;
    row: number;
    keyboardLayout: number[];
    keyboardData: any[];
  }> = [];

  for (let rowIndex = 0; rowIndex < rowLimit; rowIndex++) {
    const physicalRow = matrix[rowIndex] ?? [];
    const keyboardLayout: number[] = [];
    for (let col = 0; col < physicalRow.length; col++) {
      const physicalKeyCode = Number(physicalRow[col] ?? 0);
      if (!physicalKeyCode) {
        keyboardLayout.push(0);
        continue;
      }
      const keyInfo = await getHfdKeyInfoByKeyCode(keyData, physicalKeyCode);
      const displayCode = Number(
        keyInfo?.xsKeycode || keyInfo?.value16 || physicalKeyCode || 0
      );
      keyboardLayout.push(Number.isFinite(displayCode) ? displayCode : 0);
    }
    rows.push({
      layer,
      row: rowIndex,
      keyboardLayout,
      keyboardData: [],
    });
  }
  return rows;
}

/**
 * 写固件前校验：半包 / 影子表 / 全零 / 脏包内容一律拒绝。
 * 展示侧可用可信缓存兜底；写回必须基于设备真实可信 keyData。
 *
 * 特例（M98 / 75Pro / 75ProTFT / huafenda98 / huafenda87 有线）：常读成全零→影子表时允许写回。
 * huafenda68（Tank68 HE 等磁轴）不豁免：半包/影子整表写入会打乱实体布局。
 * huafenda98 / huafenda87（X87 V2）的 2.4G 写路径在 readHfdKeyDataWritableDirect 单独处理（脏包用出厂底座，防实体错乱）。
 * 其它机型逻辑不变。
 */
export async function evaluateHfdKeyDataForFirmwareWrite(
  keyboardType: string,
  normalized: {
    keyData: any[];
    incomplete?: boolean;
    usedShadow?: boolean;
    wasAllZero?: boolean;
  }
): Promise<{ ok: true } | { ok: false; message: string }> {
  const kb = String(keyboardType || "");

  if (!Array.isArray(normalized.keyData) || normalized.keyData.length === 0) {
    return { ok: false, message: "HFD键位数据为空，暂无法改键" };
  }

  // 仅下列机型：有 128 槽即可写（含影子出厂底座）；
  // huafenda98 / huafenda87 2.4G 不经此分支（走出厂底座回退）
  // 注意：huafenda68（含 Tank68 HE 磁轴）不可走此豁免——影子/半包整表 setKeyData 会打乱实体键位
  if (
    kb === "M98" ||
    kb === "M98 8K" ||
    kb === "75Pro" ||
    kb === "75ProTFT" ||
    kb === "huafenda98" ||
    kb === "huafenda87" ||
    kb === "x75gc" ||
    kb === "DK108" ||
    kb === "63" // 华奋达 DK63Star（布局对齐星闪 DK63 V2）
  ) {
    return { ok: true };
  }

  if (normalized.usedShadow) {
    return { ok: false, message: HFD_KEYDATA_INCOMPLETE_MSG };
  }
  if (normalized.wasAllZero) {
    return {
      ok: false,
      message: "HFD键位数据未初始化，请先完成默认布局填充后再尝试改键",
    };
  }
  if (normalized.incomplete) {
    return { ok: false, message: HFD_KEYDATA_INCOMPLETE_MSG };
  }
  try {
    const rows = await buildHfdSdkRowsFromKeyData(kb, normalized.keyData);
    if (isHfdDecodedLayoutUntrusted(rows, kb)) {
      return { ok: false, message: HFD_KEYDATA_UNTRUSTED_MSG };
    }
  } catch {
    return { ok: false, message: HFD_KEYDATA_UNTRUSTED_MSG };
  }
  return { ok: true };
}

export type HfdVirtualKeyboardLayoutResult = {
  rows: Array<{
    layer: number;
    row: number;
    keyboardLayout: number[];
    keyboardData?: any[];
    ledBeads?: any;
  }>;
  keyData: any[];
  incomplete: boolean;
  usedShadow: boolean;
  wasAllZero: boolean;
  usedStaticFallback: boolean;
  /** 使用了上次可信改键缓存（非出厂静态） */
  usedTrustedCache?: boolean;
  /**
   * 改键回显场景下设备侧解码仍不可信时丢弃结果，保留本地已 patch 的布局。
   */
  discardResult?: boolean;
};

function cloneTrustedOrStaticRows(
  rows: HfdVirtualKeyboardLayoutResult["rows"]
): HfdVirtualKeyboardLayoutResult["rows"] {
  return rows.map((r) => ({
    layer: Number(r.layer ?? 0),
    row: Number(r.row ?? 0),
    keyboardLayout: Array.isArray(r.keyboardLayout)
      ? r.keyboardLayout.map((c) => Number(c ?? 0))
      : [],
    keyboardData: [],
  }));
}

/**
 * 华奋达虚拟键盘布局唯一推荐入口：
 * 读 keyData → 可信则采用并写入可信缓存；
 * 脏包/半包优先回退「上次可信改键」，禁止无故回退出厂默认。
 */
export async function resolveHfdVirtualKeyboardLayout(options: {
  getKeyData: () => Promise<any>;
  keyboardType: string;
  layer?: number;
  totalRows?: number;
  maxReadAttempts?: number;
  maxLayoutAttempts?: number;
  retryDelayMs?: number;
  /**
   * 是否允许在「无可信缓存」时用出厂静态矩阵。
   * 改键回显（remapped）应为 false。
   */
  allowStaticFallback?: boolean;
  /** 上次可信布局；不传则内部读 localStorage */
  getTrustedRows?: () => HfdVirtualKeyboardLayoutResult["rows"] | null;
}): Promise<HfdVirtualKeyboardLayoutResult> {
  const keyboardType = String(options.keyboardType || "");
  const layer = options.layer ?? 0;
  const retryDelayMs = options.retryDelayMs ?? 150;
  const allowStaticFallback = options.allowStaticFallback !== false;
  const maxReadAttempts = Math.max(1, options.maxReadAttempts ?? 5);
  const needsValidate =
    layer === 0 && shouldValidateHfdLayoutAgainstDefault(keyboardType);
  const maxLayoutAttempts = Math.max(
    1,
    options.maxLayoutAttempts ?? (needsValidate ? 5 : 1)
  );

  /** 严格可信：通过脏包启发式，可继续写入跨页缓存 */
  const resolveTrustedFallback = ():
    | HfdVirtualKeyboardLayoutResult["rows"]
    | null => {
    const fromOpt = options.getTrustedRows?.();
    if (
      fromOpt?.length &&
      !isHfdDecodedLayoutUntrusted(fromOpt, keyboardType)
    ) {
      return cloneTrustedOrStaticRows(fromOpt);
    }
    const cached = getHfdTrustedLayoutRows(keyboardType, layer);
    if (cached?.length && !isHfdDecodedLayoutUntrusted(cached, keyboardType)) {
      return cloneTrustedOrStaticRows(cached);
    }
    return null;
  };

  /**
   * 展示兜底：改键后本地已 patch 的缓存即使启发式偏严也优先采用，
   * 避免 2.4G 脏包时 discard 导致「保留空/旧界面」。
   */
  const resolveDisplayTrustedFallback = ():
    | HfdVirtualKeyboardLayoutResult["rows"]
    | null => {
    const strict = resolveTrustedFallback();
    if (strict?.length) return strict;
    const fromOpt = options.getTrustedRows?.();
    if (fromOpt?.length) return cloneTrustedOrStaticRows(fromOpt);
    const cached = getHfdTrustedLayoutRows(keyboardType, layer);
    if (cached?.length) return cloneTrustedOrStaticRows(cached);
    return null;
  };

  const fallbackUntrusted = (
    lastKeyData: any[],
    flags: {
      incomplete: boolean;
      usedShadow: boolean;
      wasAllZero: boolean;
    }
  ): HfdVirtualKeyboardLayoutResult => {
    const trusted = resolveDisplayTrustedFallback();
    if (trusted?.length) {
      return {
        rows: trusted,
        keyData: lastKeyData,
        incomplete: flags.incomplete,
        usedShadow: flags.usedShadow,
        wasAllZero: flags.wasAllZero,
        usedStaticFallback: false,
        usedTrustedCache: true,
      };
    }
    if (allowStaticFallback) {
      return {
        rows: buildHfdStaticLayoutRows(keyboardType, layer),
        keyData: lastKeyData,
        incomplete: flags.incomplete,
        usedShadow: flags.usedShadow,
        wasAllZero: flags.wasAllZero,
        usedStaticFallback: true,
      };
    }
    return {
      rows: [],
      keyData: lastKeyData,
      incomplete: flags.incomplete,
      usedShadow: flags.usedShadow,
      wasAllZero: flags.wasAllZero,
      usedStaticFallback: false,
      discardResult: true,
    };
  };

  let lastKeyData: any[] = normalizeHfdFlatKeyData([]);
  let lastIncomplete = true;
  let lastUsedShadow = false;
  let lastWasAllZero = true;
  let lastRows: HfdVirtualKeyboardLayoutResult["rows"] = [];

  for (
    let layoutAttempt = 0;
    layoutAttempt < maxLayoutAttempts;
    layoutAttempt++
  ) {
    const normalized = await readHfdKeyDataReady(
      options.getKeyData,
      keyboardType,
      { maxAttempts: maxReadAttempts, retryDelayMs }
    );
    lastKeyData = normalized.keyData;
    lastIncomplete = Boolean(normalized.incomplete);
    lastUsedShadow = Boolean(normalized.usedShadow);
    lastWasAllZero = Boolean(normalized.wasAllZero);

    const integrityBad = shouldUseHfdStaticLayoutFallback([], keyboardType, {
      keyDataIncomplete: lastIncomplete,
      usedShadow: lastUsedShadow,
      wasAllZero: lastWasAllZero,
      integrityOnly: true,
    });

    if (integrityBad) {
      if (layoutAttempt < maxLayoutAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
        continue;
      }
      return fallbackUntrusted(lastKeyData, {
        incomplete: lastIncomplete,
        usedShadow: lastUsedShadow,
        wasAllZero: lastWasAllZero,
      });
    }

    lastRows = await buildHfdSdkRowsFromKeyData(
      keyboardType,
      lastKeyData,
      layer,
      options.totalRows
    );

    // 2.4G 脏包：完整长度但内容错乱
    if (isHfdDecodedLayoutUntrusted(lastRows, keyboardType)) {
      if (layoutAttempt < maxLayoutAttempts - 1) {
        await new Promise((resolve) => setTimeout(resolve, retryDelayMs));
        continue;
      }
      return fallbackUntrusted(lastKeyData, {
        incomplete: true,
        usedShadow: lastUsedShadow,
        wasAllZero: lastWasAllZero,
      });
    }

    // 可信：出厂一致或用户改键 — 写入跨页可信缓存
    try {
      setHfdTrustedLayoutRows(
        keyboardType,
        layer,
        lastRows as HfdTrustedLayoutRow[]
      );
    } catch {
      // ignore
    }
    break;
  }

  if (
    lastRows.length &&
    shouldUseHfdStaticLayoutFallback(lastRows, keyboardType, {
      keyDataIncomplete: lastIncomplete,
      usedShadow: lastUsedShadow,
      wasAllZero: lastWasAllZero,
    })
  ) {
    return fallbackUntrusted(lastKeyData, {
      incomplete: lastIncomplete,
      usedShadow: lastUsedShadow,
      wasAllZero: lastWasAllZero,
    });
  }

  if (lastRows.length && !isHfdDecodedLayoutUntrusted(lastRows, keyboardType)) {
    try {
      setHfdTrustedLayoutRows(
        keyboardType,
        layer,
        lastRows as HfdTrustedLayoutRow[]
      );
    } catch {
      // ignore
    }
  }

  return {
    rows: lastRows,
    keyData: lastKeyData,
    incomplete: lastIncomplete,
    usedShadow: lastUsedShadow,
    wasAllZero: lastWasAllZero,
    usedStaticFallback: false,
    usedTrustedCache: false,
  };
}

// 通过params1, params2, params3的值判断，获取按键数据
export const getKeyInfoByParams = (data: any, data1: any) => {
  if (!data || !data1) return false;
  if (
    String(data.param1) === "0" &&
    String(data.param2) === "0" &&
    String(data.param3) === "0"
  )
    return false;

  const isParam1Match = data1.valuePar1 === data.param1;
  const isParam2Match = data1.valuePar2 === data.param2;

  if (!isParam1Match || !isParam2Match) return false;

  // param3匹配
  const hasDataParam3 = "param3" in data;
  const hasData1ValuePar3 = "valuePar3" in data1;
  if (hasDataParam3 && hasData1ValuePar3) {
    return data1.valuePar3 === data.param3;
  }
  // 所有必选条件匹配成功
  return true;
};

/**
 * 生成设备专属的 hfdMacroKeyData 存储 key
 * 通过 vendorId + productId + keyboardType 区分不同 HFD 键盘的宏数据
 */
export function getHfdMacroStorageKey(): string {
  try {
    const raw =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("equipmentData")
        : null;
    if (!raw) return "hfdMacroKeyData";
    const eq = JSON.parse(raw);
    const vendorId = eq?.vendorId ?? "";
    const productId = eq?.productId ?? "";
    const keyboardType = eq?.keyboardType ?? "";
    if (!vendorId && !productId && !keyboardType) return "hfdMacroKeyData";
    return `hfdMacroKeyData:${vendorId}:${productId}:${keyboardType}`;
  } catch {
    return "hfdMacroKeyData";
  }
}

/**
 * 华奋达宏页写入的 localStorage
 */
function getHfdMacroFromLocalStorage(macroIndex: number): {
  param2: number;
  param3: number;
} {
  const fallback = { param2: 0x00, param3: 0 };
  const param2List = [0x01, 0x02, 0x03, 0x04];
  if (typeof localStorage === "undefined") return fallback;

  // 优先读取设备专属 key，向后兼容旧版通用 key
  const storageKey = getHfdMacroStorageKey();
  let raw = localStorage.getItem(storageKey);
  if (!raw) {
    raw = localStorage.getItem("hfdMacroKeyData");
  }
  if (!raw) return fallback;
  const map = JSON.parse(raw) as Record<
    string,
    { mode?: number; repNum?: number } | null
  >;
  const p = map[String(macroIndex)];
  if (!p || typeof p !== "object") return fallback;
  const rep = p.repNum ?? 1;
  const mode = p.mode ?? 0;
  return { param2: param2List[mode], param3: rep };
}

/**
 * 解析目标按键数据，转化为 HFD 协议需要的 userKey 格式
 */
const resolveTargetUserKey = (params: any, afterKeycodeData: any) => {
  // 场景 A: 未命中 ALL_KEYBOARD_MAP_HFD 时，优先基础键 / 宏
  if (!afterKeycodeData) {
    const targetKeycode = Number(params.keycode);
    const basicHit = KEYBOARD_BASIC_MAP_HFD.find(
      (item: any) => Number(item.value16) === targetKeycode
    );
    if (basicHit) {
      return {
        name: basicHit.name,
        value: Number(basicHit.value16),
        page: "KEYBOARD",
      };
    }
    const targetValue = KEYCODE_MAP[params.keycode];
    if (targetValue?.typeof === "basic" && targetKeycode > 0) {
      return {
        name: targetValue.name,
        value: targetKeycode,
        page: "KEYBOARD",
      };
    }
    if (targetValue) {
      const macroIdx = Number(targetValue.index ?? 0);
      const { param2, param3 } = getHfdMacroFromLocalStorage(macroIdx);
      return {
        name: targetValue.name,
        page: "MACRO",
        param1: macroIdx,
        param2,
        param3,
      };
    }
    return null;
  }

  // 场景 B: 替换为普通按键、鼠标或功能键
  let finalValue =
    afterKeycodeData.xsKeycode ||
    afterKeycodeData.value16 ||
    afterKeycodeData.valuePar2 ||
    "";

  // 针对特定页面的优先级调整
  const priorityPages = ["MOUSE", "FUNC", "CONSUMER_KEY"];
  if (
    priorityPages.includes(afterKeycodeData.page) ||
    afterKeycodeData.name === "Fn"
  ) {
    finalValue =
      afterKeycodeData.value16 ||
      afterKeycodeData.valuePar2 ||
      afterKeycodeData.xsKeycode ||
      "";
    // Fn 键特殊逻辑：valuePar2 优先级最高
    if (afterKeycodeData.name === "Fn") {
      finalValue = afterKeycodeData.valuePar2 || finalValue;
    }
  }

  return {
    name: afterKeycodeData.name, // 按键名称
    value: finalValue, // 按键值
    page: afterKeycodeData.page, // 页面类型：键盘按键
  };
};

// 通过拖动按键到指定行列，获取改键数据改到哪个键
// export const getKeyMapHfd = async (
//   params: any,
//   layoutData: any,
//   keycodeMapHfd: any
// ) => {
//   console.log(params, layoutData, keycodeMapHfd);
//   const beforeKeycode: any = layoutData[params.row][params.col];
//   const beforeIndex: any = KEYCODE_MAP_HFD.find(
//     (item: any) => item.keycode === beforeKeycode
//   )?.keyIndex;
//   // const beforeKeycodeData = await getHfdKeyInfoByKeyCode(keycodeMapHfd, beforeKeycode);
//   const afterKeycodeData: any = ALL_KEYBOARD_MAP_HFD.find(
//     (item: any) =>
//       item.xsKeycode === params.keycode || item.value16 === params.keycode
//   );
//   const beforeKeycodeInfo = [];
//   for (let i = 0; i < keycodeMapHfd.length; i++) {
//     const keyCodeItem = keycodeMapHfd[i];
//     const pageType = keyCodeItem.pageType;
//     if (pageType === 6) {
//       let obj: any = {
//         value: i, // 按键标号
//         userKey: {
//           name: `M${keyCodeItem.param1}`, // 宏按键显示名称
//           page: "MACRO", // 页面类型：宏按键
//           param1: keyCodeItem.param1, // 宏编号（0~99，对应 macroId）
//           param2: keyCodeItem.param1, // 重发模式：播放一次
//           param3: keyCodeItem.param3, // 重发次数（当模式为固定次数时有效）
//         },
//       };
//       // 目标键当前是宏时，也要允许被替换为普通键（如空格）
//       if (beforeIndex === i) {
//         if (!afterKeycodeData) {
//           const NEW_KEYCODE_MAP = new Map();
//           Object.entries(KEYCODE_MAP).forEach(([key, value]) => {
//             NEW_KEYCODE_MAP.set(key, value);
//           });
//           let xsKeycode: any = "";
//           let macroName = "";
//           const targetValue = NEW_KEYCODE_MAP.get(String(params.keycode));
//           if (targetValue) {
//             xsKeycode = targetValue.index;
//             macroName = targetValue.name;
//           }
//           if (macroName) {
//             obj = {
//               value: i,
//               userKey: {
//                 name: macroName,
//                 page: "MACRO",
//                 param1: xsKeycode,
//                 param2: 0x00,
//                 param3: 0,
//               },
//             };
//           }
//         } else {
//           let value1 =
//             afterKeycodeData.xsKeycode ||
//             afterKeycodeData.value16 ||
//             afterKeycodeData.valuePar2 ||
//             "";
//           if (
//             afterKeycodeData.page === "MOUSE" ||
//             afterKeycodeData.page === "FUNC" ||
//             afterKeycodeData.page === "CONSUMER_KEY"
//           ) {
//             value1 =
//               afterKeycodeData.value16 ||
//               afterKeycodeData.valuePar2 ||
//               afterKeycodeData.xsKeycode ||
//               "";
//           }
//           if (afterKeycodeData.name === "Fn") {
//             value1 =
//               afterKeycodeData.valuePar2 ||
//               afterKeycodeData.value16 ||
//               afterKeycodeData.xsKeycode ||
//               "";
//           }
//           obj = {
//             value: i,
//             userKey: {
//               name: afterKeycodeData.name,
//               value: value1,
//               page: afterKeycodeData.page,
//             },
//           };
//         }
//       }
//       beforeKeycodeInfo.push(obj);
//     } else {
//       const data = await getKeyDataByPageName(keyCodeItem.pageType);
//       const p = data.find((items: any) => {
//         return getKeyInfoByParams(keyCodeItem, items);
//       });
//       const name = p?.name || "";
//       let value = p?.xsKeycode || p?.value16 || "";
//       if (
//         p?.page === "MOUSE" ||
//         p?.page === "FUNC" ||
//         p?.page === "CONSUMER_KEY"
//       ) {
//         value = p?.value16 || p?.valuePar2 || p?.xsKeycode || "";
//       }
//       if (name === "Fn") {
//         value = p?.valuePar2 || p?.value16 || p?.xsKeycode || "";
//       }

//       // const page = KEYBOARD_PAGETYPE_HFD.find(
//       //   (item: any) => item.value === pageType
//       // )?.label;
//       const page = NEW_KEYBOARD_PAGETYPE_HFD.get(pageType)?.label;
//       let obj: any = {
//         value: i, // 按键标号
//         userKey: {
//           name, // 按键名称
//           value, // 按键值
//           page, // 页面类型：键盘按键
//         },
//       };
//       if (beforeIndex === i) {
//         if (!afterKeycodeData) {
//           // let xsKeycode: any = "";
//           // let macroName = "";
//           // Object.entries(KEYCODE_MAP).forEach(([key, value]) => {
//           //   if (Number(key) === params.keycode) {
//           //     xsKeycode = value.index;
//           //     macroName = value.name;
//           //   }
//           // });
//           // 将对象 KEYCODE_MAP 转换为 Map，键保持原始字符串类型（后续查找时统一转数字匹配）
//           const NEW_KEYCODE_MAP = new Map();
//           Object.entries(KEYCODE_MAP).forEach(([key, value]) => {
//             NEW_KEYCODE_MAP.set(key, value);
//           });
//           // 2. 根据 params.keycode 查找对应值（核心查找逻辑）
//           let xsKeycode: any = "";
//           let macroName = "";
//           // 先获取匹配的value（将params.keycode转字符串匹配Map的键，再判断数字相等）
//           const targetValue = NEW_KEYCODE_MAP.get(String(params.keycode));
//           if (targetValue) {
//             xsKeycode = targetValue.index;
//             macroName = targetValue.name;
//           }
//           if (macroName) {
//             obj = {
//               value: i, // 按键标号
//               userKey: {
//                 name: macroName, // 宏按键显示名称
//                 page: "MACRO", // 页面类型：宏按键
//                 param1: xsKeycode, // 宏编号（0~99，对应 macroId）
//                 param2: 0x00, // 重发模式：播放一次
//                 param3: 0, // 重发次数（当模式为固定次数时有效）
//               },
//             };
//           }
//         } else {
//           let value1 =
//             afterKeycodeData.xsKeycode ||
//             afterKeycodeData.value16 ||
//             afterKeycodeData.valuePar2 ||
//             "";
//           if (
//             afterKeycodeData.page === "MOUSE" ||
//             afterKeycodeData.page === "FUNC" ||
//             afterKeycodeData.page === "CONSUMER_KEY"
//           ) {
//             value1 =
//               afterKeycodeData.value16 ||
//               afterKeycodeData.valuePar2 ||
//               afterKeycodeData.xsKeycode ||
//               "";
//           }
//           if (afterKeycodeData.name === "Fn") {
//             value1 =
//               afterKeycodeData.valuePar2 ||
//               afterKeycodeData.value16 ||
//               afterKeycodeData.xsKeycode ||
//               "";
//           }
//           obj = {
//             value: i, // 按键标号
//             userKey: {
//               name: afterKeycodeData.name, // 按键名称
//               value: value1, // 按键值
//               page: afterKeycodeData.page, // 页面类型：键盘按键
//             },
//           };
//         }
//       }
//       beforeKeycodeInfo.push(obj);
//     }
//   }
//   const ROWS = 6;
//   const COLS = 21;
//   const afterKeycodeInfo: any = [];
//   for (let rowIndex = 0; rowIndex < ROWS; rowIndex++) {
//     const start = rowIndex * COLS;
//     const end = start + COLS;
//     afterKeycodeInfo.push(beforeKeycodeInfo.slice(start, end));
//   }
//   // console.log(beforeKeycodeInfo);
//   // debugger
//   return afterKeycodeInfo;
// };
// 通过拖动按键到指定行列，获取改键数据改到哪个键
export type HfdKeyRemapChange = { row: number; col: number; keycode: number };

function packHfdSetKeyDataRows(
  beforeKeycodeInfo: Array<{ value: number; userKey?: Record<string, unknown> }>
): any[][] {
  const COLS = 21;
  const ROWS = Math.ceil(HFD_KEY_SLOT_COUNT / COLS);
  const afterKeycodeInfo: any[] = [];
  for (let rowIndex = 0; rowIndex < ROWS; rowIndex++) {
    const start = rowIndex * COLS;
    const end = start + COLS;
    afterKeycodeInfo.push(beforeKeycodeInfo.slice(start, end));
  }
  return afterKeycodeInfo;
}

/** 改键目标：优先 KEYBOARD 基础键，避免 value16 与 FUNC 键冲突（如 82 被误命中为「切换 USB 模式」） */
function resolveHfdRemapTargetKeyData(targetKeycode: number) {
  const code = Number(targetKeycode);
  if (!Number.isFinite(code) || code <= 0) return undefined;
  return (
    KEYBOARD_BASIC_MAP_HFD.find(
      (item: any) =>
        item.value16 === code ||
        item.valuePar2 === code ||
        item.xsKeycode === code
    ) ??
    ALL_KEYBOARD_MAP_HFD.find(
      (item: any) =>
        item.page === "KEYBOARD" &&
        (item.xsKeycode === code || item.value16 === code)
    ) ??
    ALL_KEYBOARD_MAP_HFD.find(
      (item: any) => item.xsKeycode === code || item.value16 === code
    )
  );
}

function buildHfdFlatSetKeyPayloadItems(
  keycodeMapHfd: any[],
  remapBySlotIndex: Map<number, number>
): Array<{ value: number; userKey?: Record<string, unknown> }> {
  const list = normalizeHfdFlatKeyData(keycodeMapHfd);
  return list.map((keyCodeItem, i) => {
    let userKey: Record<string, unknown> | null = null;
    if (remapBySlotIndex.has(i)) {
      const targetKeycode = remapBySlotIndex.get(i)!;
      const afterKeycodeData = resolveHfdRemapTargetKeyData(targetKeycode);
      userKey = resolveTargetUserKey(
        { keycode: targetKeycode },
        afterKeycodeData
      );
      if (userKey) {
        return { value: i, userKey };
      }
      return { value: i };
    }
    if (!userKey) {
      userKey = hfdSlotToSetKeyUserKey(keyCodeItem, i);
    }
    if (!userKey && i < HFD_PHYSICAL_SLOT_COUNT) {
      userKey = hfdSlotToSetKeyUserKey({ ...EMPTY_HFD_SLOT }, i);
    }
    if (!userKey) {
      return { value: i };
    }
    return { value: i, userKey };
  });
}

function buildHfdSetKeyDataPayload(
  keycodeMapHfd: any[],
  remapBySlotIndex: Map<number, number>
): any[][] {
  return packHfdSetKeyDataRows(
    buildHfdFlatSetKeyPayloadItems(keycodeMapHfd, remapBySlotIndex)
  );
}

/** xsKeycode / 华奋达 consumer 键 → 展示名（旋钮绑定、板载预览等） */
export function resolveHfdXsKeycodeLabel(keycode: number): string {
  const code = Number(keycode);
  if (!Number.isFinite(code) || code <= 0) return "";

  const fromAll = ALL_KEYBOARD_MAP_HFD.find(
    (item: { xsKeycode?: number; keycode?: number; value16?: number }) =>
      Number(item.xsKeycode) === code ||
      Number(item.keycode) === code ||
      Number(item.value16) === code
  );
  if (fromAll?.name) return String(fromAll.name);
  if (fromAll?.desc) return String(fromAll.desc);

  const fromBasic = KEYCODE_MAP_HFD.find(
    (item: { keycode?: number; name?: string }) => Number(item.keycode) === code
  );
  if (fromBasic?.name) return String(fromBasic.name);

  return "";
}

/** 从 keyData 单槽解码展示用 keycode（虚拟键盘 / 旋钮 demo 回显） */
export function decodeHfdSlotToDisplayKeycode(slot: unknown): number {
  if (!slot || typeof slot !== "object") return 0;
  const pageType = Number((slot as { pageType?: unknown }).pageType ?? 0);
  const param1 = Number((slot as { param1?: unknown }).param1 ?? 0);
  const param2 = Number((slot as { param2?: unknown }).param2 ?? 0);
  const param3 = Number((slot as { param3?: unknown }).param3 ?? 0);
  if (pageType === 0 && param1 === 0 && param2 === 0 && param3 === 0) {
    return 0;
  }
  if (pageType === 2 && param2 > 0) {
    return param2;
  }
  if (pageType === 3) {
    const hit = ALL_KEYBOARD_MAP_HFD.find(
      (item: any) =>
        item.page === "CONSUMER_KEY" &&
        (Number(item.valuePar1) === param1 ||
          Number(item.param1) === param1 ||
          Number(item.value16) === (param1 | (param2 << 8)))
    );
    return Number(hit?.xsKeycode ?? param1);
  }
  if (pageType === 1) {
    const hit = MOUSE_MAP_HFD.find(
      (item: any) =>
        Number(item.param1) === param1 && Number(item.param2) === param2
    );
    return Number(hit?.xsKeycode ?? 0);
  }
  if (pageType === 6) {
    return Number(param1);
  }
  const funcHit = ALL_KEYBOARD_MAP_HFD.find(
    (item: any) => item.page === "FUNC" && Number(item.valuePar3) === param3
  );
  return Number(funcHit?.xsKeycode ?? 0);
}

/**
 * 华奋达 setKeyData：矩阵 rows + 可选 wheelKeys（旋钮/滚轮独立槽位）。
 * @see https://docs.driveall.cn/keyboard/custom-keys.html
 */
export function buildHfdSetKeyDataPayloadWithWheelKeys(
  keycodeMapHfd: any[],
  remapBySlotIndex: Map<number, number>,
  wheelSlotIndices: readonly number[]
): {
  rows: any[][];
  wheelKeys: Array<{ value: number; userKey: Record<string, unknown> }>;
} {
  const flat = buildHfdFlatSetKeyPayloadItems(keycodeMapHfd, remapBySlotIndex);
  const wheelKeys = wheelSlotIndices
    .map((idx) => flat[idx])
    .filter(
      (item): item is { value: number; userKey: Record<string, unknown> } =>
        Boolean(item?.userKey)
    )
    .map((item) => ({ value: item.value, userKey: item.userKey }));
  return {
    rows: packHfdSetKeyDataRows(flat),
    wheelKeys,
  };
}

function resolveHfdRemapSlotIndices(
  changes: HfdKeyRemapChange[],
  layoutData: number[][] | null | undefined
): Map<number, number> | null {
  if (!Array.isArray(layoutData) || !layoutData.length) return null;
  const remapBySlotIndex = new Map<number, number>();
  for (const change of changes) {
    const matrixRow = layoutData[change.row];
    if (!Array.isArray(matrixRow)) continue;
    const beforeKeycode = Number(matrixRow[change.col] ?? 0);
    if (!beforeKeycode) continue;
    const beforeIndex =
      NEW_KEYCODE_TO_INDEX_HFD.get(beforeKeycode) ??
      KEYCODE_MAP_HFD.find((item: any) => item.keycode === beforeKeycode)
        ?.keyIndex;
    if (beforeIndex == null || !Number.isFinite(beforeIndex)) continue;
    // 同槽位多次写入时后者覆盖（WASD 互换等多键批量）
    remapBySlotIndex.set(beforeIndex, change.keycode);
  }
  if (remapBySlotIndex.size === 0) return null;
  return remapBySlotIndex;
}

/** 华丰达批量改键：单次 setKeyData，避免 8 次整表读写搞乱实体键位 */
export const getKeyMapHfdBatch = async (
  changes: HfdKeyRemapChange[],
  layoutData: number[][],
  keycodeMapHfd: any[]
): Promise<any[][] | null> => {
  const remapBySlotIndex = resolveHfdRemapSlotIndices(changes, layoutData);
  if (!remapBySlotIndex) return null;
  return buildHfdSetKeyDataPayload(keycodeMapHfd, remapBySlotIndex);
};

export const getKeyMapHfd = async (
  params: any,
  layoutData: any,
  keycodeMapHfd: any
): Promise<any[][] | null> => {
  // 槽位解析失败时禁止整表写回（否则会把脏底座原样烧进固件）
  return getKeyMapHfdBatch(
    [{ row: params.row, col: params.col, keycode: params.keycode }],
    layoutData,
    keycodeMapHfd
  );
};

/**
 * 将华奋达 flat keyData 转为 `setKeyData` 所需的二维列表。
 * SDK 每次写入 128 槽完整矩阵，未正确编码的槽位会被清零，必须全量可靠编码。
 */
export const hfdFlatKeyDataToSetKeyDataRows = async (
  keycodeMapHfd: any[],
  macroRepeatPatch?: { macroId: number; param2: number; param3: number }
) => {
  const COLS = 21;
  const ROWS = Math.ceil(HFD_KEY_SLOT_COUNT / COLS);
  const list = normalizeHfdFlatKeyData(keycodeMapHfd);

  const beforeKeycodeInfo = list.map((raw, i) => {
    let keyCodeItem = raw ?? { ...EMPTY_HFD_SLOT };
    if (
      macroRepeatPatch &&
      Number(keyCodeItem.pageType) === 6 &&
      Number(keyCodeItem.param1) === Number(macroRepeatPatch.macroId)
    ) {
      keyCodeItem = {
        ...keyCodeItem,
        param2: macroRepeatPatch.param2,
        param3: macroRepeatPatch.param3,
      };
    }
    let userKey = hfdSlotToSetKeyUserKey(keyCodeItem, i);
    if (!userKey && i < HFD_PHYSICAL_SLOT_COUNT) {
      userKey = hfdSlotToSetKeyUserKey({ ...EMPTY_HFD_SLOT }, i);
    }
    if (!userKey) {
      return { value: i };
    }
    return { value: i, userKey };
  });

  const afterKeycodeInfo: any[] = [];
  for (let rowIndex = 0; rowIndex < ROWS; rowIndex++) {
    const start = rowIndex * COLS;
    const end = start + COLS;
    afterKeycodeInfo.push(beforeKeycodeInfo.slice(start, end));
  }
  return afterKeycodeInfo;
};
